<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
        </section>

        <section class="dp-right">
            <div v-if="!schoolDepartmentId" class="no-dept-tip">
                <i class="el-icon-info"></i> 请在左侧选择学校
            </div>

            <template v-else>
                <el-tabs v-model="pageTab" type="card" class="page-tabs">

                    <!-- ══════════════════════════ 德育分发放 Tab ══════════════════════════ -->
                    <el-tab-pane label="德育分发放" name="pool">
                        <div class="top-bar">
                            <span class="top-label">学期</span>
                            <el-select v-model="semesterId" placeholder="选择学期" size="small" style="width:180px;"
                                :disabled="!zheshangEnabled" @change="onSemesterChange">
                                <el-option v-for="s in semesters" :key="s.Id" :label="s.SemesterName" :value="s.Id" />
                            </el-select>
                            <span class="top-dept">学校：{{ schoolName }}</span>
                        </div>
                        <el-alert v-if="!zheshangEnabled" class="zheshang-mode-alert" type="warning" show-icon
                            :closable="false" title="当前校区未启用哲商模式"
                            description="请在「德育配置」中将业务模式设为「哲商模式」后，再使用班级池发放、来源类型管理与实体币核销等功能。" />

                        <el-tabs v-model="activeTab" type="border-card" class="main-tabs"
                            :class="{ 'main-tabs--disabled': !zheshangEnabled }">
                            <!-- ── Tab1：班级池管理 ── -->
                            <el-tab-pane label="班级池管理" name="pool">
                                <div class="tab-toolbar">
                                    <el-button type="primary" size="small" icon="el-icon-plus"
                                        :disabled="!zheshangEnabled" @click="openGrantDialog">向班级发放德育分</el-button>
                                    <el-button size="small" icon="el-icon-setting" :disabled="!zheshangEnabled"
                                        @click="openGrantSourceTypeDialog">来源类型管理</el-button>
                                    <span class="toolbar-field-label">班级</span>
                                    <el-select v-model="poolClassFilter" placeholder="全部（可筛选单班减轻请求量）" clearable
                                        filterable size="small" style="width:220px;" @change="onPoolClassFilterChange">
                                        <el-option v-for="d in classDepts" :key="d.Id" :label="d.Name" :value="d.Id" />
                                    </el-select>
                                    <el-button size="small" icon="el-icon-refresh" :disabled="!zheshangEnabled"
                                        @click="refreshAccounts">刷新</el-button>
                                    <span class="pool-hint-text">
                                        <template v-if="zheshangEvalUsesTeacherLimit">
                                            先看<strong>现在可换币</strong>；点「怎么算的」再看下发、划拨与历史发分。
                                        </template>
                                        <template v-else>
                                            <strong>可用</strong>是班级池剩余；右侧为发分累计与可兑余额；任课额度为已用/剩余。
                                        </template>
                                    </span>
                                </div>
                                <div class="tbl-scroll-host">
                                <el-table :data="pagedAccounts" border stripe size="small" v-loading="accountLoading"
                                    height="100%"
                                    :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                                    :cell-style="{ textAlign: 'center' }" style="width:100%;">
                                    <el-table-column prop="ClassName" label="班级" align="left" min-width="120" />
                                    <el-table-column prop="TotalGranted" :label="zheshangEvalUsesTeacherLimit ? '学校已下发' : '累计发放'" min-width="110">
                                        <template slot-scope="{row}">
                                            <span class="score-value">{{ row.TotalGranted }}</span>
                                        </template>
                                    </el-table-column>
                                    <!-- 新模式：列表只保留「现在可换币」一个主数字 -->
                                    <el-table-column v-if="zheshangEvalUsesTeacherLimit" min-width="140" align="center">
                                        <template slot="header">
                                            <div class="moral-pool-issued-head">
                                                <span class="moral-pool-issued-head-main">现在可换币</span>
                                                <span class="moral-pool-issued-head-sub">班级池剩余</span>
                                            </div>
                                        </template>
                                        <template slot-scope="{row}">
                                            <span class="moral-pool-slash-cell">
                                                <span class="score-remain" style="font-size:16px;font-weight:700;">{{
                                                    formatIssuedNum(poolRowRedeemable(row)) }}</span>
                                                <span class="issued-bd-chip teacher-quota-chip" role="button"
                                                    title="查看怎么算出来的"
                                                    @click="openIssuedBreakdownDialog(row, 'pool')">怎么算的</span>
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <!-- 旧模式：保留可用 / 发分与可兑 / 任课额度 -->
                                    <template v-else>
                                        <el-table-column label="可用" width="88">
                                            <template slot-scope="{row}">
                                                <span :class="row.AvailableBalance > 0 ? 'score-remain' : 'score-zero'">{{
                                                    row.AvailableBalance }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="168" align="center">
                                            <template slot="header">
                                                <div class="moral-pool-issued-head">
                                                    <span class="moral-pool-issued-head-main">发分与点评</span>
                                                    <span class="moral-pool-issued-head-sub">累计 / 可兑余额</span>
                                                </div>
                                            </template>
                                            <template slot-scope="{row}">
                                                <span class="moral-pool-slash-cell">
                                                    <span class="moral-pool-issued-v--gross">{{
                                                        formatIssuedNum(poolRowIssuedGross(row)) }}</span>
                                                    <span class="quota-slash">/</span>
                                                    <span
                                                        class="moral-pool-issued-v--net issued-bd-ref issued-bd-ref--click"
                                                        role="button" title="查看分项构成"
                                                        @click="openIssuedBreakdownDialog(row, 'pool')">{{
                                                            formatIssuedNum(poolRowRedeemable(row)) }}</span>
                                                    <span class="issued-bd-chip teacher-quota-chip" role="button"
                                                        title="查看分项构成"
                                                        @click="openIssuedBreakdownDialog(row, 'pool')">构成</span>
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="168" align="center">
                                            <template slot="header">
                                                <div class="moral-pool-issued-head">
                                                    <span class="moral-pool-issued-head-main">任课额度</span>
                                                    <span class="moral-pool-issued-head-sub">已用 / 剩余</span>
                                                </div>
                                            </template>
                                            <template slot-scope="{row}">
                                                <span class="score-issued">{{ row.SubjectTeacherQuotaUsedSum || 0 }}</span>
                                                <span class="quota-slash">/</span>
                                                <span class="score-remain">{{ row.SubjectTeacherQuotaRemainingSum || 0
                                                }}</span>
                                                <span class="issued-bd-chip teacher-quota-chip" role="button"
                                                    title="各任课教师额度明细"
                                                    @click="openTeacherQuotaDetailDialog(row)">明细</span>
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table>
                                </div>
                                <div class="pagination-bar">
                                    <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                                        :page-sizes="paginationPageSizes" :total="filteredPoolAccounts.length"
                                        :page-size="accountPageSize" :current-page="accountPage"
                                        @size-change="onAccountPageSizeChange"
                                        @current-change="p => { accountPage = p; }" />
                                </div>
                            </el-tab-pane>

                            <!-- ── Tab2：实体币核销 ── -->
                            <el-tab-pane label="实体币核销" name="writeoff">
                                <div class="tab-toolbar">
                                    <el-button type="warning" size="small" icon="el-icon-coin" :disabled="!zheshangEnabled"
                                        @click="openWriteOffDialog">登记实体币核销</el-button>
                                    <span class="toolbar-field-label">流水日期</span>
                                    <el-date-picker v-model="writeOffBizDateRange" type="daterange" unlink-panels
                                        append-to-body start-placeholder="开始" end-placeholder="结束"
                                        value-format="yyyy-MM-dd" size="small" clearable style="width:300px;"
                                        @change="onWriteOffBizDateRangeChange" />
                                    <el-button size="small" icon="el-icon-refresh" :disabled="!zheshangEnabled"
                                        @click="refreshWriteOffLedger">刷新</el-button>
                                </div>
                                <div class="tbl-scroll-host">
                                <el-table :data="writeOffLedger" border stripe size="small" v-loading="writeOffLoading"
                                    height="100%"
                                    :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                                    :cell-style="{ textAlign: 'center' }" style="width:100%;">
                                    <el-table-column prop="ClassName" label="班级" align="left" />
                                    <el-table-column prop="DeltaPoints" label="扣除分值">
                                        <template slot-scope="{row}">
                                            <span class="score-issued">{{ Math.abs(row.DeltaPoints) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Remark" label="备注/关联信息" align="left" />
                                    <el-table-column prop="BizTime" label="时间" width="150">
                                        <template slot-scope="{row}">{{ formatTime(row.BizTime) }}</template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="110">
                                        <template slot-scope="{row}">
                                            <el-button v-if="zheshangEnabled && canShowPhysicalCoinWriteOffRevoke(row)" type="text"
                                                size="mini" style="color:#F56C6C;"
                                                @click="revokeWriteOff(row)">撤回</el-button>
                                            <span v-else-if="row.LedgerType === 'PhysicalCoinWriteOff'"
                                                class="writeoff-revoked-hint">已撤回</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                </div>
                                <div class="pagination-bar">
                                    <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                                        :page-sizes="paginationPageSizes" :total="writeOffTotal"
                                        :page-size="writeOffPageSize" :current-page="writeOffPage"
                                        @size-change="onWriteOffPageSizeChange"
                                        @current-change="p => { writeOffPage = p; loadWriteOffLedger(); }" />
                                </div>
                            </el-tab-pane>

                            <!-- ── Tab3：全校流水 ── -->
                            <el-tab-pane label="全校流水" name="ledger">
                                <div class="tab-toolbar">
                                    <el-select v-model="ledgerClassFilter" placeholder="全部班级（可搜索）" clearable filterable
                                        size="small" style="width:200px;"
                                        @change="() => { ledgerPage = 1; loadLedger(); }">
                                        <el-option v-for="d in classDepts" :key="d.Id" :label="d.Name" :value="d.Id" />
                                    </el-select>
                                    <el-select v-model="ledgerTypeFilter" placeholder="全部类型" clearable
                                        size="small" style="width:150px;"
                                        @change="() => { ledgerPage = 1; loadLedger(); }">
                                        <el-option v-for="opt in ledgerTypeOptions" :key="opt.value"
                                            :label="opt.label" :value="opt.value" />
                                    </el-select>
                                    <span class="toolbar-field-label">流水日期</span>
                                    <el-date-picker v-model="ledgerBizDateRange" type="daterange" unlink-panels
                                        append-to-body start-placeholder="开始" end-placeholder="结束"
                                        value-format="yyyy-MM-dd" size="small" clearable style="width:260px;"
                                        @change="onLedgerBizDateRangeChange" />
                                    <el-button size="small" icon="el-icon-refresh-left" :disabled="!zheshangEnabled"
                                        @click="resetLedgerFilters">重置</el-button>
                                    <el-button size="small" icon="el-icon-refresh" :disabled="!zheshangEnabled"
                                        @click="refreshLedger">刷新</el-button>
                                    <el-button type="warning" size="small" icon="el-icon-download"
                                        :disabled="!zheshangEnabled" :loading="ledgerExporting"
                                        @click="exportLedger">导出</el-button>
                                </div>
                                <div class="tbl-scroll-host">
                                <el-table :data="ledgerRows" border stripe size="small" v-loading="ledgerLoading"
                                    height="100%"
                                    :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                                    :cell-style="{ textAlign: 'center' }" style="width:100%;">
                                    <el-table-column prop="ClassName" label="班级" align="left" min-width="110" />
                                    <el-table-column label="操作人 / 角色" min-width="140" align="left">
                                        <template slot-scope="{row}">{{ ledgerOperatorDisplay(row) }}</template>
                                    </el-table-column>
                                    <el-table-column label="关联学生" min-width="100" align="left">
                                        <template slot-scope="{row}">
                                            <span>{{ row.TargetStudentName || '—' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="关联任课" min-width="100" align="left">
                                        <template slot-scope="{row}">
                                            <span>{{ row.TargetTeacherName || '—' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="类型" width="130">
                                        <template slot-scope="{row}">
                                            <el-tag :type="ledgerTypeTagType(row.LedgerType)" size="small">
                                                {{ row.LedgerTypeDisplay || row.ledgerTypeDisplay || row.LedgerType }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="来源类型" width="110" align="left">
                                        <template slot-scope="{row}">
                                            <span>{{ row.GrantSourceTypeName || (row.LedgerType === 'AdminGrant' || row.LedgerType === 'AdminGrantRevoke' ? '—' : '') }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="DeltaPoints" label="分值">
                                        <template slot-scope="{row}">
                                            <span :class="row.DeltaPoints < 0 ? 'score-issued' : 'score-value'">
                                                {{ row.DeltaPoints > 0 ? '+' : '' }}{{ row.DeltaPoints }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Remark" label="备注" align="left" />
                                    <el-table-column prop="BizTime" label="时间" width="150">
                                        <template slot-scope="{row}">{{ formatTime(row.BizTime) }}</template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="110">
                                        <template slot-scope="{row}">
                                            <el-button v-if="zheshangEnabled && canShowAdminGrantRevoke(row)" type="text" size="mini"
                                                style="color:#F56C6C;" @click="revokeGrant(row)">撤回</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                </div>
                                <div class="pagination-bar">
                                    <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                                        :page-sizes="paginationPageSizes" :total="ledgerTotal"
                                        :page-size="ledgerPageSize" :current-page="ledgerPage"
                                        @size-change="onLedgerPageSizeChange"
                                        @current-change="p => { ledgerPage = p; loadLedger(); }" />
                                </div>

                            </el-tab-pane>

                            <!-- ── Tab4：汇总排行 ── -->
                            <el-tab-pane label="汇总排行" name="rank">
                                <div class="tbl-scroll-host">
                                <el-table :data="pagedRankingList" border size="small" empty-text="暂无数据，请先选择学期"
                                    height="100%"
                                    :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                                    :cell-style="{ textAlign: 'center' }" style="width:100%;">
                                    <el-table-column label="排行" width="70">
                                        <template slot-scope="{$index}">
                                            <span v-if="rankingGlobalPlace($index) === 1" class="medal medal-gold">{{
                                                rankingGlobalPlace($index) }}</span>
                                            <span v-else-if="rankingGlobalPlace($index) === 2"
                                                class="medal medal-silver">{{ rankingGlobalPlace($index) }}</span>
                                            <span v-else-if="rankingGlobalPlace($index) === 3"
                                                class="medal medal-bronze">{{ rankingGlobalPlace($index) }}</span>
                                            <span v-else class="rank-num">{{ rankingGlobalPlace($index) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ClassName" label="班级" align="left" min-width="120" />
                                    <el-table-column :label="zheshangEvalUsesTeacherLimit ? '学校已下发' : '德育总分'" min-width="110">
                                        <template slot-scope="{row}">
                                            <span class="score-value" style="font-size:15px;">{{ row.TotalGranted
                                            }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="zheshangEvalUsesTeacherLimit" min-width="140" align="center">
                                        <template slot="header">
                                            <div class="moral-pool-issued-head">
                                                <span class="moral-pool-issued-head-main">现在可换币</span>
                                                <span class="moral-pool-issued-head-sub">班级池剩余</span>
                                            </div>
                                        </template>
                                        <template slot-scope="{row}">
                                            <span class="moral-pool-slash-cell">
                                                <span class="score-remain" style="font-size:16px;font-weight:700;">{{
                                                    formatIssuedNum(poolRowRedeemable(row)) }}</span>
                                                <span class="issued-bd-chip teacher-quota-chip" role="button"
                                                    title="查看怎么算出来的"
                                                    @click="openIssuedBreakdownDialog(row, 'rank')">怎么算的</span>
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <template v-else>
                                        <el-table-column label="可用" width="88">
                                            <template slot-scope="{row}">
                                                <span :class="row.AvailableBalance > 0 ? 'score-remain' : 'score-zero'">{{
                                                    row.AvailableBalance }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="168" align="center">
                                            <template slot="header">
                                                <div class="moral-pool-issued-head">
                                                    <span class="moral-pool-issued-head-main">发分与点评</span>
                                                    <span class="moral-pool-issued-head-sub">累计 / 可兑余额</span>
                                                </div>
                                            </template>
                                            <template slot-scope="{row}">
                                                <span class="moral-pool-slash-cell">
                                                    <span class="moral-pool-issued-v--gross">{{
                                                        formatIssuedNum(poolRowIssuedGross(row)) }}</span>
                                                    <span class="quota-slash">/</span>
                                                    <span
                                                        class="moral-pool-issued-v--net issued-bd-ref issued-bd-ref--click"
                                                        role="button" title="查看分项构成"
                                                        @click="openIssuedBreakdownDialog(row, 'rank')">{{
                                                            formatIssuedNum(poolRowRedeemable(row)) }}</span>
                                                    <span class="issued-bd-chip teacher-quota-chip" role="button"
                                                        title="查看分项构成"
                                                        @click="openIssuedBreakdownDialog(row, 'rank')">构成</span>
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="158" align="center">
                                            <template slot="header">
                                                <div class="moral-pool-issued-head">
                                                    <span class="moral-pool-issued-head-main">任课额度</span>
                                                    <span class="moral-pool-issued-head-sub">已用 / 剩余</span>
                                                </div>
                                            </template>
                                            <template slot-scope="{row}">
                                                <span class="score-issued">{{ row.SubjectTeacherQuotaUsedSum || 0 }}</span>
                                                <span class="quota-slash">/</span>
                                                <span class="score-remain">{{ row.SubjectTeacherQuotaRemainingSum || 0
                                                }}</span>
                                                <span class="issued-bd-chip teacher-quota-chip" role="button"
                                                    title="各任课教师额度明细"
                                                    @click="openTeacherQuotaDetailDialog(row)">明细</span>
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table>
                                </div>
                                <div class="pagination-bar">
                                    <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                                        :page-sizes="paginationPageSizes" :total="rankingList.length"
                                        :page-size="rankPageSize" :current-page="rankPage"
                                        @size-change="onRankPageSizeChange" @current-change="p => { rankPage = p; }" />
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>

                    <!-- ══════════════════════════ 流动红旗查询 Tab ══════════════════════════ -->
                    <el-tab-pane label="流动红旗查询" name="flag">
                        <div class="query-bar">
                            <div class="query-row">
                                <span class="top-label">查询模式</span>
                                <el-radio-group v-model="flagPeriodMode" size="small" @change="onFlagModeChange">
                                    <el-radio-button :label="0">按周</el-radio-button>
                                    <el-radio-button :label="1">按月</el-radio-button>
                                </el-radio-group>

                                <template v-if="flagPeriodMode === 0">
                                    <span class="top-label">学期</span>
                                    <el-select v-model="flagSemesterId" placeholder="选择学期" size="small"
                                        style="width:180px;" @change="onFlagSemesterChange(true)">
                                        <el-option v-for="s in semesters" :key="s.Id" :label="s.SemesterName"
                                            :value="s.Id" />
                                    </el-select>
                                    <span class="top-label">周次</span>
                                    <el-select v-model="flagWeekNumber" placeholder="全部周" clearable size="small"
                                        class="toolbar-field-w-week" @change="flagQueryBarChange">
                                        <el-option v-for="w in flagWeeks" :key="w.WeekNumber" :label="w.Label"
                                            :value="w.WeekNumber" />
                                    </el-select>
                                </template>

                                <template v-if="flagPeriodMode === 1">
                                    <span class="top-label">月份</span>
                                    <el-date-picker v-model="flagPeriodMonth" type="month" placeholder="选择月份"
                                        size="small" style="width:150px;" value-format="yyyyMM"
                                        @change="flagQueryBarChange" />
                                </template>

                                <span class="top-label">年级</span>
                                <el-select v-model="flagGradeId" placeholder="全部年级" clearable filterable size="small"
                                    style="width:150px;" @change="flagQueryBarChange">
                                    <el-option v-for="g in grades" :key="g.Id" :label="g.Name" :value="g.Id" />
                                </el-select>

                                <el-button type="primary" size="small" icon="el-icon-search" @click="flagQueryBarChange"
                                    :loading="flagLoading">查询</el-button>
                            </div>
                        </div>

                        <div class="tbl-scroll-host">
                        <el-table :data="flagTableData" v-loading="flagLoading" border stripe size="small"
                            height="100%"
                            row-key="DepartmentId" empty-text="暂无数据，请选择查询条件后点击查询"
                            :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                            :cell-style="{ textAlign: 'center' }" style="width:100%;">
                            <el-table-column label="排名" width="60">
                                <template slot-scope="{$index}">
                                    {{ (flagPage - 1) * flagPageSize + $index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="DepartmentName" label="班级" align="left" />
                            <el-table-column prop="FlagCount" label="红旗次数" width="100">
                                <template slot-scope="{row}">
                                    <span :class="row.FlagCount > 0 ? 'flag-count' : 'flag-zero'">
                                        <i v-if="row.FlagCount > 0" class="el-icon-flag" style="margin-right:2px;"></i>
                                        {{ row.FlagCount }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="明细" min-width="300" align="left">
                                <template slot-scope="{row}">
                                    <span v-if="!row.Weeks || row.Weeks.length === 0"
                                        style="color:#c0c4cc;font-size:12px;">暂无</span>
                                    <div v-for="w in row.Weeks" :key="w.RecordId" class="flag-summary-card"
                                        :class="flagSummaryCardClass(w)" role="button" tabindex="0"
                                        @click="openFlagDetailDialog(row, w)"
                                        @keydown.enter="openFlagDetailDialog(row, w)">
                                        <div class="flag-summary-card-top">
                                            <span class="flag-summary-period">{{ w.WeekLabel || '红旗记录' }}</span>
                                            <span class="flag-summary-score">{{ flagFormatScore(w.TotalScore) }}</span>
                                        </div>
                                        <div v-if="w.ReviewTeacherName || w.FlagName" class="flag-summary-card-mid">
                                            <span v-if="w.FlagName" class="flag-summary-flagname">{{ w.FlagName
                                            }}</span>
                                            <span v-if="w.ReviewTeacherName" class="flag-summary-review">
                                                复核：{{ w.ReviewTeacherName }}
                                            </span>
                                        </div>
                                        <div class="flag-summary-card-foot">
                                            <span class="flag-summary-tip">点击查看完整信息</span>
                                            <i class="el-icon-arrow-right"></i>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        </div>
                        <div class="pagination-bar">
                            <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                                :page-sizes="flagPaginationPageSizes" :total="flagTotal" :page-size="flagPageSize"
                                :current-page="flagPage" @size-change="onFlagPageSizeChange"
                                @current-change="onFlagPageChange" />
                        </div>
                    </el-tab-pane>

                </el-tabs>
            </template>

            <!-- ── 发放德育分弹窗 ── -->
            <el-dialog title="向班级池发放德育分" :visible.sync="grantDialogVisible" width="560px" :close-on-click-modal="false"
                @close="resetGrantForm">
                <el-form :model="grantForm" :rules="grantRules" ref="grantFormRef" label-width="80px" size="small">

                    <!-- 活动类型 -->
                    <el-form-item label="活动类型">
                        <el-radio-group v-model="grantActivityType" @change="onGrantActivityTypeChange">
                            <el-radio-button label="normal">常规活动</el-radio-button>
                            <el-radio-button label="weekFlag">周流动红旗</el-radio-button>
                            <el-radio-button label="monthFlag">月流动红旗</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <!-- 常规活动：年级 → 班级级联 -->
                    <el-form-item v-if="grantActivityType === 'normal'" label="年级">
                        <el-select v-model="grantGradeId" placeholder="选择年级" clearable filterable style="width:100%;"
                            @change="onGrantGradeChange">
                            <el-option v-for="g in grades" :key="g.Id" :label="g.Name" :value="g.Id" />
                        </el-select>
                    </el-form-item>

                    <!-- 周流动红旗：学期 + 周次 + 自动选班 -->
                    <template v-if="grantActivityType === 'weekFlag'">
                        <el-form-item label="学期">
                            <el-select v-model="grantFlagSemesterId" placeholder="选择学期" style="width:100%;"
                                @change="loadGrantFlagWeeks">
                                <el-option v-for="s in semesters" :key="s.Id" :label="s.SemesterName" :value="s.Id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="周次">
                            <div style="display:flex;gap:8px;">
                                <el-select v-model="grantFlagWeekNumber" placeholder="选择周次（可选）" clearable
                                    style="flex:1;">
                                    <el-option v-for="w in grantFlagWeeks" :key="w.WeekNumber" :label="w.Label"
                                        :value="w.WeekNumber" />
                                </el-select>
                                <el-button size="small" type="primary" plain :loading="grantFlagLoading"
                                    @click="autoSelectFlagClasses">
                                    自动选取红旗班级
                                </el-button>
                            </div>
                        </el-form-item>
                    </template>

                    <!-- 月流动积分：月份 + 自动选班 -->
                    <el-form-item v-if="grantActivityType === 'monthFlag'" label="月份">
                        <div style="display:flex;gap:8px;">
                            <el-date-picker v-model="grantFlagMonth" type="month" placeholder="选择月份"
                                value-format="yyyyMM" style="flex:1;" />
                            <el-button size="small" type="primary" plain :loading="grantFlagLoading"
                                @click="autoSelectFlagClasses">
                                自动选取红旗班级
                            </el-button>
                        </div>
                    </el-form-item>

                    <!-- 目标班级（所有模式共用） -->
                    <el-form-item label="目标班级" prop="classIds">
                        <el-select v-model="grantForm.classIds" multiple filterable collapse-tags
                            placeholder="选择班级（可多选）" style="width:100%;"
                            :disabled="grantActivityType === 'normal' && !grantGradeId">
                            <el-option v-for="d in grantAvailableClasses" :key="d.Id" :label="d.Name" :value="d.Id" />
                        </el-select>
                        <div style="display:flex;justify-content:space-between;align-items:center;margin-top:4px;">
                            <span style="font-size:12px;color:#909399;">
                                已选 {{ grantForm.classIds.length }} / {{ grantAvailableClasses.length }} 个班级
                            </span>
                            <span style="font-size:12px;">
                                <el-button type="text" size="mini" style="padding:0;"
                                    @click="grantForm.classIds = grantAvailableClasses.map(d => d.Id)">全选</el-button>
                                <el-divider direction="vertical" />
                                <el-button type="text" size="mini" style="padding:0;color:#909399;"
                                    @click="grantForm.classIds = []">清空</el-button>
                            </span>
                        </div>
                    </el-form-item>

                    <el-form-item label="发放分值" prop="points">
                        <el-input-number v-model="grantForm.points" :min="1" :precision="0" style="width:100%;" />
                    </el-form-item>
                    <el-form-item label="来源类型" prop="grantSourceTypeId">
                        <el-select v-model="grantForm.grantSourceTypeId" placeholder="请选择来源类型" filterable
                            style="width:100%;">
                            <el-option v-for="t in grantSourceTypesEnabled" :key="t.Id" :label="t.Name" :value="t.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="grantForm.remark" maxlength="100" show-word-limit placeholder="如：荣获本周流动红旗" />
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="grantDialogVisible = false">取消</el-button>
                    <el-button type="primary" :loading="grantSubmitting" @click="submitGrant">
                        确认发放（{{ grantForm.classIds.length }} 个班级）
                    </el-button>
                </div>
            </el-dialog>

            <!-- ── 来源类型管理弹窗 ── -->
            <el-dialog title="发分来源类型管理" :visible.sync="grantSourceTypeDialogVisible" width="720px"
                custom-class="grant-source-type-dialog" :close-on-click-modal="false" @open="loadGrantSourceTypesAll">
                <div class="grant-source-type-panel">
                    <div class="grant-source-type-toolbar">
                        <div class="grant-source-type-toolbar__actions">
                            <el-button type="primary" size="small" icon="el-icon-plus"
                                @click="openGrantSourceTypeEdit()">新增类型</el-button>
                            <el-button size="small" icon="el-icon-magic-stick" plain
                                :loading="grantSourceTypeInitLoading" @click="initDefaultGrantSourceTypes">初始化默认</el-button>
                            <el-button size="small" icon="el-icon-refresh" plain
                                @click="loadGrantSourceTypesAll">刷新</el-button>
                        </div>
                        <span class="grant-source-type-toolbar__hint">发放班级池时标注来源，并用于驾驶舱饼图配色</span>
                    </div>
                    <div class="grant-source-type-table-wrap">
                        <el-table :data="grantSourceTypePagedList" stripe size="small"
                            :height="grantSourceTypeTableHeight" v-loading="grantSourceTypeLoading"
                            :header-cell-style="{ textAlign: 'center', background: '#f8fafc', color: '#606266', fontWeight: '600' }"
                            :cell-style="{ textAlign: 'center' }">
                            <template slot="empty">
                                <div class="grant-source-type-empty">
                                    <i class="el-icon-collection-tag grant-source-type-empty__icon"></i>
                                    <p class="grant-source-type-empty__title">暂无来源类型</p>
                                    <p class="grant-source-type-empty__desc">点击「初始化默认」可快速创建文明班级、活动获奖等 5 项常用类型</p>
                                </div>
                            </template>
                            <el-table-column prop="SortOrder" label="排序" width="68" align="center" />
                            <el-table-column prop="Name" label="名称" align="left" min-width="120"
                                show-overflow-tooltip />
                            <el-table-column label="颜色" width="96" align="center">
                                <template slot-scope="{row}">
                                    <span v-if="row.Color" class="grant-source-type-color-chip"
                                        :style="{ '--chip-color': row.Color }" :title="row.Color">
                                        <i class="grant-source-type-color-dot" :style="{ background: row.Color }"></i>
                                        <span class="grant-source-type-color-hex">{{ row.Color }}</span>
                                    </span>
                                    <span v-else class="grant-source-type-color-empty">未设置</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" width="76" align="center">
                                <template slot-scope="{row}">
                                    <el-tag :type="row.Enabled ? 'success' : 'info'" size="mini" effect="plain">
                                        {{ row.Enabled ? '启用' : '禁用' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="140" align="center" fixed="right">
                                <template slot-scope="{row}">
                                    <el-button type="text" size="mini" class="grant-source-type-op-btn"
                                        @click="openGrantSourceTypeEdit(row)">编辑</el-button>
                                    <el-button type="text" size="mini" class="grant-source-type-op-btn"
                                        :class="{ 'is-danger': row.Enabled }"
                                        @click="toggleGrantSourceTypeEnabled(row)">
                                        {{ row.Enabled ? '禁用' : '启用' }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="grantSourceTypesAll.length > grantSourceTypePageSize" class="grant-source-type-footer">
                        <el-pagination background layout="total, prev, pager, next"
                            :total="grantSourceTypesAll.length" :page-size="grantSourceTypePageSize"
                            :current-page="grantSourceTypePage" @current-change="onGrantSourceTypePageChange" />
                    </div>
                </div>
            </el-dialog>

            <!-- ── 初始化默认来源类型确认 ── -->
            <el-dialog title="初始化默认来源类型" :visible.sync="grantSourceTypeInitConfirmVisible" width="460px"
                append-to-body custom-class="grant-source-type-init-dialog" :close-on-click-modal="false">
                <p class="grant-source-type-init-desc">将新增以下 {{ grantSourceTypeInitPending.length }} 项，已存在的同名类型会自动跳过：</p>
                <ul class="grant-source-type-init-list">
                    <li v-for="item in grantSourceTypeInitPending" :key="item.name" class="grant-source-type-init-item">
                        <span class="grant-source-type-init-swatch" :style="{ background: item.color }"></span>
                        <span class="grant-source-type-init-name">{{ item.name }}</span>
                        <span class="grant-source-type-init-hex">{{ item.color }}</span>
                    </li>
                </ul>
                <div slot="footer" class="grant-source-type-init-footer">
                    <el-button size="small" @click="grantSourceTypeInitConfirmVisible = false">取消</el-button>
                    <el-button type="primary" size="small" :loading="grantSourceTypeInitLoading"
                        @click="confirmInitDefaultGrantSourceTypes">确定创建</el-button>
                </div>
            </el-dialog>

            <!-- ── 来源类型编辑子弹窗 ── -->
            <el-dialog :title="grantSourceTypeEditForm.Id ? '编辑来源类型' : '新增来源类型'"
                :visible.sync="grantSourceTypeEditVisible" width="560px" append-to-body :close-on-click-modal="false">
                <el-form :model="grantSourceTypeEditForm" ref="grantSourceTypeEditRef" label-width="80px" size="small">
                    <el-form-item label="名称" prop="Name" :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]">
                        <el-input v-model="grantSourceTypeEditForm.Name" maxlength="50" />
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number v-model="grantSourceTypeEditForm.SortOrder" :min="0" :max="9999" />
                    </el-form-item>
                    <el-form-item label="颜色">
                        <preset-color-picker v-model="grantSourceTypeEditForm.Color" :presets="grantSourceColorPresets"
                            fallback-color="#2f805f" />
                    </el-form-item>
                    <el-form-item label="启用">
                        <el-switch v-model="grantSourceTypeEditForm.Enabled" />
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="grantSourceTypeEditVisible = false">取消</el-button>
                    <el-button type="primary" :loading="grantSourceTypeSaving" @click="submitGrantSourceTypeEdit">保存</el-button>
                </div>
            </el-dialog>

            <!-- ── 实体币核销弹窗 ── -->
            <el-dialog title="登记实体币核销" :visible.sync="writeOffDialogVisible" width="520px" :close-on-click-modal="false"
                @close="resetWriteOffForm">
                <el-form :model="writeOffForm" :rules="writeOffRules" ref="writeOffFormRef" label-width="100px"
                    size="small">
                    <el-form-item label="年级">
                        <el-select v-model="writeOffGradeId" placeholder="选择年级" clearable filterable style="width:100%;"
                            @change="onWriteOffGradeChange">
                            <el-option v-for="g in grades" :key="g.Id" :label="g.Name" :value="g.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="班级" prop="classId">
                        <el-select v-model="writeOffForm.classId" placeholder="选择班级" filterable style="width:100%;"
                            :disabled="!writeOffGradeId" @change="onWriteOffClassChange">
                            <el-option v-for="d in writeOffGradeClasses" :key="d.Id" :label="d.Name" :value="d.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="writeOffForm.classId" :label="zheshangEvalUsesTeacherLimit ? '可核销额度' : '可兑参考'" class="writeoff-pool-form-item">
                        <div v-loading="writeOffAccountLoading" class="writeoff-pool-hint-wrap">
                            <div v-if="writeOffPoolHint" class="writeoff-pool-card">
                                <div class="writeoff-pool-hero">
                                    <div class="writeoff-pool-hero-label">{{ zheshangEvalUsesTeacherLimit ? '现在可核销（班级池剩余）' : '可兑余额' }}</div>
                                    <div class="writeoff-pool-hero-value">{{ formatIssuedNum(writeOffPoolHint.redeemable) }}</div>
                                    <div class="writeoff-pool-hero-tip">{{ zheshangEvalUsesTeacherLimit ? '登记核销只扣这个数' : '核销只扣此项' }}</div>
                                </div>
                                <div v-if="zheshangEvalUsesTeacherLimit" class="writeoff-pool-deduct-note">
                                    本学期学校已下发 {{ formatIssuedNum(writeOffPoolHint.totalAdminGranted) }} 分。核销按班级池剩余扣减，不必再看发分明细。
                                </div>
                                <div v-else class="writeoff-pool-stats">
                                    <div class="writeoff-pool-stat">
                                        <div class="writeoff-pool-stat-label">班级池剩余</div>
                                        <div class="writeoff-pool-stat-value writeoff-pool-stat-value--avail">
                                            {{ formatIssuedNum(writeOffPoolHint.available) }}
                                        </div>
                                    </div>
                                    <div class="writeoff-pool-stat">
                                        <div class="writeoff-pool-stat-label">发分与点评累计</div>
                                        <div class="writeoff-pool-stat-value writeoff-pool-stat-value--gross">
                                            {{ formatIssuedNum(writeOffPoolHint.issuedGross) }}
                                        </div>
                                    </div>
                                    <div class="writeoff-pool-stat">
                                        <div class="writeoff-pool-stat-label">已核销净影响</div>
                                        <div class="writeoff-pool-stat-value">
                                            {{ formatIssuedNum(writeOffPoolHint.writeOffNet) }}
                                        </div>
                                    </div>
                                    <div class="writeoff-pool-stat">
                                        <div class="writeoff-pool-stat-label">管理员累计下发</div>
                                        <div class="writeoff-pool-stat-value">
                                            {{ formatIssuedNum(writeOffPoolHint.totalAdminGranted) }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!zheshangEvalUsesTeacherLimit" class="writeoff-pool-deduct-note">
                                    可兑余额 = 发分与点评累计 + 已核销净影响；班级池剩余仅供参考，核销不调整。
                                </div>
                            </div>
                            <div v-else-if="writeOffPoolHintMissing" class="writeoff-pool-miss">
                                当前学期暂无该班班级池数据，请先在「德育分发放 → 班级池管理」向本班发放德育分后重开弹窗或刷新页面。
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="扣除分值" prop="points">
                        <template v-if="writeOffForm.classId && writeOffPoolHint && writeOffPoolHint.redeemable <= 0">
                            <el-alert type="warning" show-icon :closable="false" title="可兑币分为 0，无法登记核销" />
                        </template>
                        <template v-else>
                            <el-input-number v-model="writeOffForm.points" :min="1" :max="writeOffPointsMaxForInput"
                                :precision="0" style="width:100%;" :disabled="!writeOffForm.classId" />
                            <div v-if="writeOffPoolHint && writeOffPoolHint.redeemable > 0" class="writeoff-deduct-tip">
                                本次最多可扣 <strong>{{ writeOffPoolHint.redeemable }}</strong> 分（不得超过可兑币分）
                            </div>
                        </template>
                    </el-form-item>
                    <el-form-item label="实体币数量">
                        <el-input-number v-model="writeOffForm.physicalCoinCount" :min="0" :precision="0"
                            style="width:100%;" placeholder="选填" />
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="writeOffForm.remark" type="textarea" :rows="2" maxlength="100"
                            show-word-limit placeholder="选填：可按需写明批次或经办说明" />
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="writeOffDialogVisible = false">取消</el-button>
                    <el-button type="warning" :loading="writeOffSubmitting" :disabled="writeOffSubmitBlocked"
                        @click="submitWriteOff">确认核销</el-button>
                </div>
            </el-dialog>

            <!-- 可兑/班级池构成（弹窗）：新模式与旧可兑逻辑分开展示。最后更新：2026-03-16 -->
            <el-dialog :title="issuedBreakdownDialogTitle" :visible.sync="issuedBreakdownDialogVisible" width="500px"
                append-to-body :close-on-click-modal="false" custom-class="issued-bd-dialog-shell"
                @close="onIssuedBreakdownDialogClose">
                <div v-if="issuedBreakdownContextRow" class="issued-bd-pop">
                    <!-- 新模式：极简单栏——答案 + 加减账。最后更新：2026-11-02 -->
                    <template v-if="zheshangEvalUsesTeacherLimit">
                        <div class="pool-explain">
                            <div class="pool-explain-answer">
                                <div class="pool-explain-eyebrow">现在可换实体币</div>
                                <div class="pool-explain-num">{{
                                    formatIssuedNum(poolRowRedeemable(issuedBreakdownContextRow)) }}</div>
                                <div class="pool-explain-meta">核销只扣这个数</div>
                            </div>
                            <div class="pool-explain-ledger">
                                <div class="pool-explain-ledger-cap">怎么算的</div>
                                <div class="pool-explain-ledger-grid">
                                    <div v-for="it in poolExplainSteps" :key="'pool' + it.k" class="pool-explain-row">
                                        <span class="pool-explain-row-k">{{ it.k }}</span>
                                        <span class="pool-explain-row-v" :class="issuedValToneClass(it.n)">{{
                                            formatPoolCalcSigned(it.n) }}</span>
                                    </div>
                                </div>
                                <div v-if="poolExplainTotal" class="pool-explain-row is-total">
                                    <span class="pool-explain-row-k">{{ poolExplainTotal.k }}</span>
                                    <span class="pool-explain-row-v is-total-v">{{ poolExplainTotal.v }}</span>
                                </div>
                            </div>
                            <p class="pool-explain-note">
                                划给任课后，任课再发分不会重复扣池；点评走教师限额，也不扣班级池。
                            </p>
                            <button type="button" class="pool-explain-more" @click="toggleIssuedHistory">
                                {{ issuedBreakdownCollapse.indexOf('issued') >= 0 ? '收起历史发分' : '查看历史发分' }}
                                <i :class="issuedBreakdownCollapse.indexOf('issued') >= 0 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                            </button>
                            <div v-if="issuedBreakdownCollapse.indexOf('issued') >= 0" class="pool-explain-history">
                                <div class="pool-explain-history-grid">
                                    <div v-for="it in issuedBreakdownItems(issuedBreakdownContextRow)"
                                        :key="'nz' + it.k" class="pool-explain-history-item">
                                        <span class="pool-explain-history-k">{{ it.k }}</span>
                                        <span class="pool-explain-history-v" :class="issuedValToneClass(it.n)">{{ it.v }}</span>
                                    </div>
                                </div>
                                <p class="pool-explain-note">合计 {{
                                    formatIssuedNum(poolRowIssuedGross(issuedBreakdownContextRow))
                                    }}，只供核对，不影响可换币。</p>
                            </div>
                        </div>
                    </template>
                    <!-- 旧模式：可兑=发分净额，分项可核对 -->
                    <template v-else>
                        <div class="issued-bd-hero">
                            <div class="issued-bd-stat-card issued-bd-stat-card--wide">
                                <div class="issued-bd-stat-caption">班级池剩余（可用）</div>
                                <div class="issued-bd-stat-value issued-bd-num-avail">{{
                                    formatIssuedNum(pickNumField(issuedBreakdownContextRow, 'availableBalance',
                                        'AvailableBalance')) }}</div>
                                <p class="issued-bd-stat-hint">班主任还可从本班池子继续发放的额度</p>
                            </div>
                            <div class="issued-bd-stat-pair">
                                <div class="issued-bd-stat-card">
                                    <div class="issued-bd-stat-caption">发分与点评累计</div>
                                    <div class="issued-bd-stat-value issued-bd-num-gross">{{
                                        formatIssuedNum(poolRowIssuedGross(issuedBreakdownContextRow)) }}</div>
                                    <p class="issued-bd-stat-hint">班主任/任课发分与点评流水合计，未扣实体币兑换</p>
                                </div>
                                <div class="issued-bd-stat-card">
                                    <div class="issued-bd-stat-caption">可兑余额</div>
                                    <div class="issued-bd-stat-value issued-bd-num-redeem">{{
                                        formatIssuedNum(poolRowRedeemable(issuedBreakdownContextRow)) }}</div>
                                    <p class="issued-bd-stat-hint">已含实体币核销等影响，与下表「核销净影响」一致</p>
                                </div>
                            </div>
                        </div>
                        <div class="issued-bd-section-bar">
                            <span class="issued-bd-section-title">分项明细</span>
                            <span class="issued-bd-section-line"></span>
                        </div>
                        <div class="issued-bd-lines">
                            <div v-for="it in issuedBreakdownItems(issuedBreakdownContextRow)" :key="'d' + it.k"
                                class="issued-bd-line">
                                <span class="issued-bd-label" :title="it.k">{{ it.k }}</span>
                                <span class="issued-bd-val" :class="issuedValToneClass(it.n)">{{ it.v }}</span>
                            </div>
                        </div>
                        <div v-if="issuedBreakdownShowDiff(issuedBreakdownContextRow)" class="issued-bd-diff">
                            <span class="issued-bd-diff-label">与账户差</span>
                            <span class="issued-bd-val issued-val-warn">{{
                                issuedBreakdownDiffText(issuedBreakdownContextRow) }}</span>
                        </div>
                    </template>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="issuedBreakdownDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>

            <!-- 任课额度：按教师明细（GetClassTeacherQuotas） -->
            <el-dialog :title="teacherQuotaDialogTitle" :visible.sync="teacherQuotaDialogVisible" width="560px"
                append-to-body :close-on-click-modal="false" custom-class="teacher-quota-dialog-shell"
                @close="resetTeacherQuotaDetailDialog">
                <div v-loading="teacherQuotaDetailLoading">
                    <p class="teacher-quota-simple-tip">
                        {{ zheshangEvalUsesTeacherLimit
                            ? '以下为当前在班任课教师的历史额度（新划拨已停用）。已调离教师不列入。'
                            : '以下为当前在班任课教师额度（不含班主任）。已调离教师不列入。' }}
                    </p>
                    <div v-if="!teacherQuotaDetailLoading"
                        class="teacher-quota-dialog-summary">
                        <div class="teacher-quota-dialog-summary-label">当前在班合计 · 已用 / 剩余</div>
                        <div class="teacher-quota-dialog-summary-nums">
                            <span class="score-issued">{{ teacherQuotaListedUsedSum }}</span>
                            <span class="quota-slash">/</span>
                            <span class="score-remain">{{ teacherQuotaListedRemainSum }}</span>
                        </div>
                    </div>
                    <p v-if="teacherQuotaDetailStale" class="teacher-quota-simple-tip teacher-quota-simple-tip--muted">
                        另有已调离教师的历史额度未列入上表。
                    </p>
                    <!-- 滚动由全局 dialog-theme 统一处理；外层勿再 overflow -->
                    <div v-if="!teacherQuotaDetailLoading && teacherQuotaDetailTeachers.length"
                        class="teacher-quota-table-wrap">
                        <el-table :data="teacherQuotaDetailTeachers" border size="small" stripe
                            class="teacher-quota-detail-table teacher-quota-detail-table--lite" style="width:100%"
                            :header-cell-style="teacherQuotaTableCellStyle" :cell-style="teacherQuotaTableCellStyle">
                            <el-table-column label="任课教师" align="center" show-overflow-tooltip>
                                <template slot-scope="scope">{{
                                    scope.row.TeacherName || scope.row.teacherName || '—'
                                    }}</template>
                            </el-table-column>
                            <el-table-column label="累计划拨" align="center">
                                <template slot-scope="scope">{{
                                    formatIssuedNum(scope.row.TotalQuota != null ? scope.row.TotalQuota :
                                        scope.row.totalQuota)
                                    }}</template>
                            </el-table-column>
                            <el-table-column label="已用" align="center">
                                <template slot-scope="scope">{{
                                    formatIssuedNum(scope.row.UsedQuota != null ? scope.row.UsedQuota :
                                        scope.row.usedQuota)
                                    }}</template>
                            </el-table-column>
                            <el-table-column label="剩余" align="center">
                                <template slot-scope="scope">{{
                                    formatIssuedNum(scope.row.RemainingQuota != null ? scope.row.RemainingQuota :
                                        scope.row.remainingQuota)
                                    }}</template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="!teacherQuotaDetailLoading && !teacherQuotaDetailTeachers.length"
                        class="teacher-quota-empty">
                        当前班级无在本班任课的任课教师（不含班主任），或暂无额度记录。
                    </div>
                </div>
                <span slot="footer" class="dialog-footer teacher-quota-dialog-footer">
                    <el-button type="primary" @click="teacherQuotaDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>

            <!-- 流动红旗 — 单条记录详情（移动端友好：点击卡片打开） -->
            <el-dialog :title="flagDetailTitle" :visible.sync="flagDetailVisible" width="480px" append-to-body
                :close-on-click-modal="false" custom-class="flag-detail-dialog-shell" @close="resetFlagDetailDialog">
                <div v-if="flagDetailWeek" class="flag-detail-sheet">
                    <div class="flag-detail-hero">
                        <div class="flag-detail-hero-label">{{ flagDetailWeek.WeekLabel || '红旗记录' }}</div>
                        <div class="flag-detail-hero-score">{{ flagFormatScore(flagDetailWeek.TotalScore) }}</div>
                    </div>

                    <div class="flag-detail-rows">
                        <div class="flag-detail-row">
                            <span class="flag-detail-k">班级</span>
                            <span class="flag-detail-v">{{ flagDetailClass && flagDetailClass.DepartmentName }}</span>
                        </div>
                        <div class="flag-detail-row">
                            <span class="flag-detail-k">旗帜</span>
                            <span class="flag-detail-v">{{ flagDetailWeek.FlagName || '流动红旗' }}</span>
                        </div>
                        <div v-if="flagDetailWeek.Star" class="flag-detail-row">
                            <span class="flag-detail-k">星级</span>
                            <span class="flag-detail-v">{{ flagDetailWeek.Star }} 星</span>
                        </div>
                        <div v-if="flagDetailWeek.Start || flagDetailWeek.End" class="flag-detail-row">
                            <span class="flag-detail-k">起止</span>
                            <span class="flag-detail-v">{{ flagShortDateRange(flagDetailWeek.Start, flagDetailWeek.End)
                            }}</span>
                        </div>
                        <template v-if="flagDetailWeek.IsReviewed">
                            <div class="flag-detail-row">
                                <span class="flag-detail-k">复核</span>
                                <span class="flag-detail-v">
                                    {{ flagDetailWeek.ReviewTeacherName || '—' }}
                                    <span v-if="flagDetailWeek.ReviewTime" class="flag-detail-sub">
                                        {{ flagShortDatetime(flagDetailWeek.ReviewTime) }}
                                    </span>
                                </span>
                            </div>
                        </template>
                        <div v-if="flagDetailWeek.IsManualAward" class="flag-detail-block flag-detail-block--manual">
                            <div class="flag-detail-k">手动赋予</div>
                            <div class="flag-detail-block-body">{{ flagDetailWeek.ManualAwardRemark || '—' }}</div>
                            <div v-if="flagDetailWeek.ManualAwardOperatorName || flagDetailWeek.ManualAwardTime"
                                class="flag-detail-sub">
                                {{ [flagDetailWeek.ManualAwardOperatorName,
                                flagShortDatetime(flagDetailWeek.ManualAwardTime)].filter(Boolean).join(' · ') }}
                            </div>
                        </div>
                        <div v-if="flagDetailWeek.IsCanceled" class="flag-detail-block flag-detail-block--cancel">
                            <div class="flag-detail-k">已取消</div>
                            <div class="flag-detail-block-body">{{ flagDetailWeek.CancelRemark || '—' }}</div>
                            <div v-if="flagDetailWeek.CancelOperatorName || flagDetailWeek.CancelTime"
                                class="flag-detail-sub">
                                {{ [flagDetailWeek.CancelOperatorName,
                                flagShortDatetime(flagDetailWeek.CancelTime)].filter(Boolean).join(' · ') }}
                            </div>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" plain @click="flagDetailVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
        </section>
    </section>
</template>

<script>
// PC 后台页：与后台同一登录态即可，不传 dutyStaffTeacherId。手机/H5 须传任教 Id 以校验 DutyStaff。
import DepartmentPane from '@/components/DepartmentPane';
import PresetColorPicker, { SCREEN_PRESET_COLORS } from '@/components/PresetColorPicker';
import { zheshangGetClassAccounts, zheshangGetClassTeacherQuotas, zheshangGetClassLedger, zheshangExportClassLedger, zheshangAdminBatchGrantClassPool, zheshangAdminRevokeGrant, zheshangGetGrantSourceTypes, zheshangSaveGrantSourceType, zheshangWriteOffPhysicalCoin, zheshangRevokeWriteOff } from '../../api/modules/moral-education';
import { getSemesterList, adminGetFlagRecords, adminGetSemesterWeeks } from '../../api/modules/misc';
import { getSubDepartmentList, getMoralConfig } from '../../api/modules/department';

/** 全校流水：类型筛选项（与后端 MoralClassPointLedgerType / LedgerTypeDisplay 一致） */
const LEDGER_TYPE_OPTIONS = [
    { value: 'AdminGrant', label: '管理员发放' },
    { value: 'AdminGrantRevoke', label: '撤回发放' },
    { value: 'StudentGrant', label: '发给学生' },
    { value: 'StudentGrantRevoke', label: '撤回学生发分' },
    { value: 'EvaluationGrant', label: '点评记学生分' },
    { value: 'TeacherQuotaAllot', label: '划拨任课额度' },
    { value: 'TeacherQuotaRevoke', label: '撤回额度' },
    { value: 'PhysicalCoinWriteOff', label: '实体币核销' },
    { value: 'PhysicalCoinWriteOffRevoke', label: '撤回核销' },
];

/** 发分来源类型：一键初始化预设（与驾驶舱 Demo 饼图图例一致） */
const DEFAULT_GRANT_SOURCE_TYPE_PRESETS = [
    { name: '文明班级', sortOrder: 1, color: '#2f805f' },
    { name: '活动获奖', sortOrder: 2, color: '#316fba' },
    { name: '卫生流动红旗', sortOrder: 3, color: '#b77824' },
    { name: '体育节', sortOrder: 4, color: '#865fa3' },
    { name: '劳动实践', sortOrder: 5, color: '#2e7d8a' },
];

/** 发分来源类型：饼图推荐色（排在 ScreenManager 预设色之前） */
const GRANT_SOURCE_PIE_COLORS = [
    { label: '哲商绿', hex: '#2f805f' },
    { label: '学院蓝', hex: '#316fba' },
    { label: '琥珀金', hex: '#b77824' },
    { label: '紫罗兰', hex: '#865fa3' },
    { label: '青碧色', hex: '#2e7d8a' },
];

/** 来源类型管理弹窗：每页条数 */
const GRANT_SOURCE_TYPE_PAGE_SIZE = 8;

/** 来源类型表格固定高度（small 表头约 40px + 8 行 × 41px） */
const GRANT_SOURCE_TYPE_TABLE_HEIGHT = 368;

export default {
    name: 'MoralClassPoolAdmin',
    components: { DepartmentPane, PresetColorPicker },
    data() {
        return {
            // 公共
            schoolDepartmentId: 0,
            schoolName: '',
            /** 当前学校是否启用哲商模式（MoralBizMode=ZheshangWest） */
            zheshangEnabled: false,
            /** 哲商点评走教师限额、班级池仅换币 */
            zheshangEvalUsesTeacherLimit: false,
            semesterId: null,
            semesters: [],
            pageTab: 'pool',
            activeTab: 'pool',
            // 年级/班级（发放弹窗、核销弹窗、红旗查询共用）
            grades: [],
            classDepts: [],
            grantGradeId: null,
            grantGradeClasses: [],
            writeOffGradeId: null,
            writeOffGradeClasses: [],
            // ── 班级池管理 Tab ──
            accounts: [],
            accountLoading: false,
            /** 仅请求并展示该班级池（与 GetClassAccounts 的 classIds 对应；清空则拉全校已有账户） */
            poolClassFilter: null,
            accountPage: 1,
            accountPageSize: 10,
            /** 汇总排行分页 */
            rankPage: 1,
            rankPageSize: 10,
            /** 各表「每页条数」下拉选项（流动红旗接口单次最大 200） */
            paginationPageSizes: [10, 20, 50, 100],
            flagPaginationPageSizes: [10, 20, 50, 100, 200],
            // ── 实体币核销 Tab ──
            writeOffLedger: [],
            writeOffLoading: false,
            writeOffTotal: 0,
            writeOffPage: 1,
            writeOffPageSize: 10,
            /** 实体币核销流水：按 BizTime 筛选，对应接口 bizDateStart/bizDateEnd */
            writeOffBizDateRange: null,
            // ── 全校流水 Tab ──
            ledgerRows: [],
            ledgerLoading: false,
            ledgerExporting: false,
            ledgerTotal: 0,
            ledgerPage: 1,
            ledgerPageSize: 10,
            ledgerClassFilter: null,
            /** 全校流水：LedgerType 筛选，空为全部 */
            ledgerTypeFilter: null,
            ledgerTypeOptions: LEDGER_TYPE_OPTIONS,
            /** 全校流水：按流水 BizTime 筛选的日期区间（yyyy-MM-dd），与接口 bizDateStart/bizDateEnd 对应 */
            ledgerBizDateRange: null,
            // ── 发放弹窗 ──
            grantDialogVisible: false,
            grantSubmitting: false,
            grantForm: { classIds: [], points: 100, remark: '', grantSourceTypeId: null },
            grantRules: {
                classIds: [{ required: true, type: 'array', min: 1, message: '请选择至少一个班级', trigger: 'change' }],
                points: [{ required: true, message: '请填写分值', trigger: 'blur' }],
                grantSourceTypeId: [{ required: true, message: '请选择来源类型', trigger: 'change' }],
            },
            /** 发放下拉：仅启用中的来源类型 */
            grantSourceTypesEnabled: [],
            /** 来源类型管理弹窗 */
            grantSourceTypeDialogVisible: false,
            grantSourceTypeEditVisible: false,
            grantSourceTypeLoading: false,
            grantSourceTypeSaving: false,
            grantSourceTypeInitLoading: false,
            grantSourceTypeInitConfirmVisible: false,
            grantSourceTypeInitPending: [],
            grantSourceTypesAll: [],
            grantSourceTypePage: 1,
            grantSourceTypePageSize: GRANT_SOURCE_TYPE_PAGE_SIZE,
            grantSourceTypeTableHeight: GRANT_SOURCE_TYPE_TABLE_HEIGHT,
            grantSourceTypeEditForm: { Id: 0, Name: '', SortOrder: 0, Color: '', Enabled: true },
            /** 来源类型颜色：饼图推荐色 + ScreenManager 同款预设 */
            grantSourceColorPresets: [...GRANT_SOURCE_PIE_COLORS, ...SCREEN_PRESET_COLORS],
            // 活动类型：normal=常规活动，weekFlag=周流动红旗，monthFlag=月流动积分
            grantActivityType: 'normal',
            grantFlagSemesterId: null,
            grantFlagWeekNumber: null,
            grantFlagWeeks: [],
            grantFlagMonth: null,
            grantFlagLoading: false,
            // 自动选取后的红旗班级列表（仅红旗模式下展示）
            grantFlagClasses: [],
            // ── 核销弹窗 ──
            writeOffDialogVisible: false,
            writeOffSubmitting: false,
            /** 核销弹窗：按所选班级单独拉取的账户行（不在打开弹窗时拉全校） */
            writeOffAccountRow: null,
            writeOffAccountLoading: false,
            writeOffForm: { classId: null, points: 1, physicalCoinCount: null, remark: '' },
            writeOffRules: {
                classId: [{ required: true, message: '请选择班级', trigger: 'change' }],
                points: [{ required: true, message: '请填写分值', trigger: 'blur' }],
            },
            /** 已发/可兑构成分解弹窗 */
            issuedBreakdownDialogVisible: false,
            /** 新模式构成弹窗折叠面板：默认收起细节 */
            issuedBreakdownCollapse: [],
            issuedBreakdownDialogTitle: '',
            issuedBreakdownContextRow: null,
            /** 任课额度按教师明细弹窗 */
            teacherQuotaDialogVisible: false,
            teacherQuotaDialogTitle: '',
            teacherQuotaDetailLoading: false,
            teacherQuotaSummaryRow: null,
            teacherQuotaDetailTeachers: [],
            teacherQuotaDetailStale: false,
            // ── 流动红旗查询 Tab ──
            flagPeriodMode: 0,
            flagSemesterId: null,
            flagWeekNumber: null,
            flagWeeks: [],
            flagPeriodMonth: null,
            flagGradeId: null,
            flagTableData: [],
            flagLoading: false,
            /** 流动红旗查询 — 分页（与接口 PageModel 对齐） */
            flagPage: 1,
            flagPageSize: 10,
            flagTotal: 0,
            /** 流动红旗 — 明细弹窗 */
            flagDetailVisible: false,
            flagDetailClass: null,
            flagDetailWeek: null,
        };
    },
    computed: {
        /** 班级池表格数据源（筛选班级时仅展示该班；数据可与后台合并缓存） */
        filteredPoolAccounts() {
            if (!this.poolClassFilter) return this.accounts || [];
            const cid = String(this.poolClassFilter);
            return (this.accounts || []).filter(a => String(a.ClassId) === cid);
        },
        /** 班级池管理分页切片 */
        pagedAccounts() {
            const list = this.filteredPoolAccounts;
            const start = (this.accountPage - 1) * this.accountPageSize;
            return list.slice(start, start + this.accountPageSize);
        },
        /** 发放弹窗可选班级：常规模式按年级过滤，红旗模式仅展示自动获取的获旗班级 */
        grantAvailableClasses() {
            if (this.grantActivityType === 'normal') return this.grantGradeClasses;
            return this.grantFlagClasses;
        },
        /** 汇总排行：按德育总分降序（与班级池筛选一致） */
        rankingList() {
            return [...this.filteredPoolAccounts].sort((a, b) => (b.TotalGranted || 0) - (a.TotalGranted || 0));
        },
        /** 汇总排行当前页（每页 rankPageSize 条） */
        pagedRankingList() {
            const list = this.rankingList;
            const start = (this.rankPage - 1) * this.rankPageSize;
            return list.slice(start, start + this.rankPageSize);
        },
        /** 来源类型管理：当前页数据 */
        grantSourceTypePagedList() {
            const list = this.grantSourceTypesAll || [];
            const start = (this.grantSourceTypePage - 1) * this.grantSourceTypePageSize;
            return list.slice(start, start + this.grantSourceTypePageSize);
        },
        /**
         * 核销弹窗所选班级：由 GetClassAccounts(classIds=单班) 拉取，与列表缓存合并。
         */
        /** 班级池列表「发分与点评」列表头副标题。创建于 2026-03-16 */
        poolIssuedColumnSubTitle() {
            return this.zheshangEvalUsesTeacherLimit ? '累计（不扣池）' : '累计 / 可兑余额';
        },
        /** 可换币说明：加减步骤（不含合计）。创建于 2026-11-02 */
        poolExplainSteps() {
            return this.poolRemainingBreakdownItems(this.issuedBreakdownContextRow).filter(x => !x.total);
        },
        /** 可换币说明：合计行 */
        poolExplainTotal() {
            return this.poolRemainingBreakdownItems(this.issuedBreakdownContextRow).find(x => x.total) || null;
        },
        /** 任课额度明细：当前在班各行之和（已用）。创建于 2026-03-16 */
        teacherQuotaListedUsedSum() {
            return (this.teacherQuotaDetailTeachers || []).reduce((sum, row) => {
                const n = Number(row && (row.UsedQuota != null ? row.UsedQuota : row.usedQuota));
                return sum + (Number.isFinite(n) ? n : 0);
            }, 0);
        },
        /** 任课额度明细：当前在班各行之和（剩余） */
        teacherQuotaListedRemainSum() {
            return (this.teacherQuotaDetailTeachers || []).reduce((sum, row) => {
                const n = Number(row && (row.RemainingQuota != null ? row.RemainingQuota : row.remainingQuota));
                return sum + (Number.isFinite(n) ? n : 0);
            }, 0);
        },
        /** 账户汇总与在班明细合计是否明显不一致 */
        teacherQuotaSummaryMismatch() {
            if (!this.teacherQuotaSummaryRow || !(this.teacherQuotaDetailTeachers || []).length) return false;
            const used = Number(this.teacherQuotaSummaryRow.SubjectTeacherQuotaUsedSum) || 0;
            const remain = Number(this.teacherQuotaSummaryRow.SubjectTeacherQuotaRemainingSum) || 0;
            return Math.abs(used - this.teacherQuotaListedUsedSum) >= 0.01
                || Math.abs(remain - this.teacherQuotaListedRemainSum) >= 0.01;
        },
        writeOffPoolHint() {
            const cid = this.writeOffForm && this.writeOffForm.classId;
            if (!cid || !this.semesterId) return null;
            const row = this.writeOffAccountRow;
            if (!row || String(row.ClassId) !== String(cid)) return null;
            const wo = this.pickNumField(row, 'issuedDetailWriteOffNet', 'IssuedDetailWriteOffNet');
            const issuedNet = this.pickNumField(row, 'issuedToStudents', 'IssuedToStudents');
            const available = this.pickNumField(row, 'availableBalance', 'AvailableBalance');
            return {
                redeemable: this.poolRowRedeemable(row),
                available,
                /** 管理员累计下发班级池（德育总分） */
                totalAdminGranted: this.pickNumField(row, 'totalGranted', 'TotalGranted'),
                /** 发分+点评等记入学生侧累计 */
                issuedGross: this.zheshangEvalUsesTeacherLimit
                    ? (this.pickNumField(row, 'issuedToStudentsGross', 'IssuedToStudentsGross') || issuedNet)
                    : (issuedNet - wo),
                writeOffNet: wo,
            };
        },
        /** 已选班级且非加载中仍无账户行 */
        writeOffPoolHintMissing() {
            return !!(this.writeOffForm && this.writeOffForm.classId && this.semesterId
                && !this.writeOffAccountLoading && !this.writeOffPoolHint);
        },
        /** 实体币核销：扣除上限 = 实体币可兑余额 */
        writeOffPointsMaxForInput() {
            const h = this.writeOffPoolHint;
            if (!h || h.redeemable <= 0) return undefined;
            return Math.trunc(h.redeemable);
        },
        /** 可兑币分为 0 时禁止提交 */
        writeOffSubmitBlocked() {
            if (!this.writeOffForm || !this.writeOffForm.classId) return false;
            const h = this.writeOffPoolHint;
            return !!(h && h.redeemable <= 0);
        },
        flagDetailTitle() {
            const n = this.flagDetailClass && this.flagDetailClass.DepartmentName;
            return n ? `红旗详情 · ${n}` : '红旗详情';
        },
    },
    watch: {
        /** 切到「流动红旗查询」时默认拉一次数据（条件齐备时静默请求） */
        pageTab(val) {
            if (val === 'flag')
                this.$nextTick(() => this.tryAutoLoadFlagData());
        },
        /** 切换班级或池子数据变化时，将扣除分值夹在 [1, 可兑币分] */
        writeOffPoolHint(h) {
            if (!h || h.redeemable <= 0) return;
            const max = Math.trunc(h.redeemable);
            const p = Number(this.writeOffForm.points);
            if (p > max) this.writeOffForm.points = max;
            else if (!Number.isFinite(p) || p < 1) this.writeOffForm.points = 1;
        },
    },
    methods: {
        /** 汇总排行：当前页内行号对应的全局名次（从 1 起） */
        rankingGlobalPlace(localIndex) {
            return (this.rankPage - 1) * this.rankPageSize + localIndex + 1;
        },
        /** 班级池：切换每页条数 */
        onAccountPageSizeChange(size) {
            this.accountPageSize = size;
            this.accountPage = 1;
        },
        /** 实体币核销流水：切换每页条数 */
        onWriteOffPageSizeChange(size) {
            this.writeOffPageSize = size;
            this.writeOffPage = 1;
            this.loadWriteOffLedger();
        },
        /** 全校流水：切换每页条数 */
        onLedgerPageSizeChange(size) {
            this.ledgerPageSize = size;
            this.ledgerPage = 1;
            this.loadLedger();
        },
        /** 汇总排行：切换每页条数 */
        onRankPageSizeChange(size) {
            this.rankPageSize = size;
            this.rankPage = 1;
        },
        /** 流动红旗查询：切换每页条数（受后端单页上限 200） */
        onFlagPageSizeChange(size) {
            this.flagPageSize = size;
            this.flagPage = 1;
            this.loadFlagData();
        },
        treeNodeClick(data) {
            if (!data || !data.value || data.value === '0') return;
            this.schoolDepartmentId = data.value;
            this.schoolName = data.label || '';
            this.zheshangEnabled = false;
            // 切换学校：清空所有数据
            this.semesterId = null;
            this.semesters = [];
            this.accounts = [];
            this.poolClassFilter = null;
            this.writeOffLedger = [];
            this.ledgerRows = [];
            this.classDepts = [];
            this.grades = [];
            // 流动红旗
            this.flagSemesterId = null;
            this.flagWeeks = [];
            this.flagWeekNumber = null;
            this.flagPeriodMonth = null;
            this.flagGradeId = null;
            this.flagTableData = [];
            // 来源类型：切换学校须清空，避免展示上一校数据
            this.grantSourceTypesEnabled = [];
            this.grantSourceTypesAll = [];
            this.grantSourceTypePage = 1;
            this.grantSourceTypeDialogVisible = false;
            this.grantForm.grantSourceTypeId = null;
            this.loadZheshangMode().then(() => {
                this.loadSemesters();
            });
        },
        /** 读取德育配置，判断是否为哲商模式及点评走教师限额子开关 */
        async loadZheshangMode() {
            if (!this.schoolDepartmentId) {
                this.zheshangEnabled = false;
                this.zheshangEvalUsesTeacherLimit = false;
                return;
            }
            try {
                const res = await getMoralConfig({ departmentId: this.schoolDepartmentId });
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};
                    const mode = resp.MoralBizMode || 'Standard';
                    this.zheshangEnabled = mode === 'ZheshangWest';
                    this.zheshangEvalUsesTeacherLimit = this.zheshangEnabled
                        && (!!resp.ZheshangEvalUsesTeacherLimit || !!resp.MoralZheshangTeacherLimitForEval);
                } else {
                    this.zheshangEnabled = false;
                    this.zheshangEvalUsesTeacherLimit = false;
                }
            } catch {
                this.zheshangEnabled = false;
                this.zheshangEvalUsesTeacherLimit = false;
            }
            if (!this.zheshangEnabled) {
                this.zheshangEvalUsesTeacherLimit = false;
                this.grantSourceTypesEnabled = [];
                this.grantSourceTypesAll = [];
            }
        },
        async loadSemesters() {
            try {
                const res = await getSemesterList({ departmentId: this.schoolDepartmentId });
                if (res && res.success && res.response && res.response.length > 0) {
                    this.semesters = res.response;
                    const cur = this.semesters.find(s => s.IsCurrent == 1 || s.IsCurrent === true) || this.semesters[0];
                    this.semesterId = cur.Id;
                    this.flagSemesterId = cur.Id;
                    this.onSemesterChange();
                    await this.onFlagSemesterChange(false);
                    if (this.flagPeriodMode === 1)
                        this.flagPeriodMonth = this.moralPrevCalendarMonthYyyyMm();
                } else {
                    this.semesters = [];
                    this.semesterId = null;
                    this.flagSemesterId = null;
                    if (this.flagPeriodMode === 1)
                        this.flagPeriodMonth = this.moralPrevCalendarMonthYyyyMm();
                }
                /* onFlagSemesterChange(false) 内会在当前为「流动红旗查询」分页时触发 tryAutoLoadFlagData */
            } catch { /* ignore */ }
        },
        onSemesterChange() {
            if (!this.semesterId || !this.zheshangEnabled) return;
            this.loadAccounts();
            this.loadClassDepts();
            this.loadWriteOffLedger();
            this.loadLedger();
            this.loadGrantSourceTypesEnabled();
        },
        async loadClassDepts() {
            try {
                const res = await getSubDepartmentList({ pid: this.schoolDepartmentId });
                const result = (res && res.data) || res;
                const list = (result && result.response) || [];
                this.grades = list.filter(d => String((d && d.DeptOrgType) || '').toLowerCase() === 'grade');
                this.classDepts = list.filter(d => String((d && d.DeptOrgType) || '').toLowerCase() === 'class');
            } catch { /* ignore */ }
        },
        async onGrantGradeChange(gradeId) {
            this.grantForm.classIds = [];
            this.grantGradeClasses = [];
            if (!gradeId) return;
            try {
                const res = await getSubDepartmentList({ pid: gradeId });
                const result = (res && res.data) || res;
                const list = (result && result.response) || [];
                this.grantGradeClasses = list.filter(d => String((d && d.DeptOrgType) || '').toLowerCase() === 'class');
            } catch { /* ignore */ }
        },
        async onWriteOffGradeChange(gradeId) {
            this.writeOffForm.classId = null;
            this.writeOffAccountRow = null;
            this.writeOffGradeClasses = [];
            if (!gradeId) return;
            try {
                const res = await getSubDepartmentList({ pid: gradeId });
                const result = (res && res.data) || res;
                const list = (result && result.response) || [];
                this.writeOffGradeClasses = list.filter(d => String((d && d.DeptOrgType) || '').toLowerCase() === 'class');
            } catch { /* ignore */ }
        },
        /** 班级池：筛选班级后只请求该班并合并进缓存，清空筛选则重新拉全校（减轻班级多时单次数据量） */
        onPoolClassFilterChange() {
            this.accountPage = 1;
            this.rankPage = 1;
            this.loadAccounts();
        },
        /** @returns {Promise<boolean>} 是否加载成功 */
        async loadAccounts() {
            if (!this.semesterId) return false;
            this.accountLoading = true;
            try {
                const params = {
                    schoolDepartmentId: this.schoolDepartmentId,
                    semesterId: this.semesterId,
                };
                if (this.poolClassFilter)
                    params.classIds = String(this.poolClassFilter);
                const res = await zheshangGetClassAccounts(params);
                if (res && res.data && res.data.success) {
                    const raw = res.data.response;
                    const newRows = Array.isArray(raw) ? raw : (raw ? [raw] : []);
                    if (this.poolClassFilter) {
                        const byClass = new Map((this.accounts || []).map(a => [String(a.ClassId), a]));
                        const fc = String(this.poolClassFilter);
                        if (newRows.length)
                            newRows.forEach(a => byClass.set(String(a.ClassId), a));
                        else
                            byClass.delete(fc);
                        this.accounts = Array.from(byClass.values());
                    } else {
                        this.accounts = newRows;
                    }
                    this.accountPage = 1;
                    this.rankPage = 1;
                    return true;
                }
                return false;
            } catch {
                return false;
            } finally {
                this.accountLoading = false;
            }
        },
        /**
         * 核销弹窗：选定班级后再请求该班账户（不写死打开弹窗即拉全校）。
         * @param {number|string|null} classId
         */
        async fetchWriteOffClassAccount(classId) {
            if (!classId || !this.semesterId) {
                this.writeOffAccountRow = null;
                return;
            }
            this.writeOffAccountLoading = true;
            try {
                const res = await zheshangGetClassAccounts({
                    schoolDepartmentId: this.schoolDepartmentId,
                    semesterId: this.semesterId,
                    classIds: String(classId),
                });
                if (res && res.data && res.data.success) {
                    const raw = res.data.response;
                    const newRows = Array.isArray(raw) ? raw : (raw ? [raw] : []);
                    this.writeOffAccountRow = newRows.length ? newRows[0] : null;
                    const byClass = new Map((this.accounts || []).map(a => [String(a.ClassId), a]));
                    if (this.writeOffAccountRow)
                        byClass.set(String(this.writeOffAccountRow.ClassId), this.writeOffAccountRow);
                    else
                        byClass.delete(String(classId));
                    this.accounts = Array.from(byClass.values());
                } else {
                    this.writeOffAccountRow = null;
                }
            } catch {
                this.writeOffAccountRow = null;
            } finally {
                this.writeOffAccountLoading = false;
            }
        },
        onWriteOffClassChange(classId) {
            this.fetchWriteOffClassAccount(classId);
        },
        /** 手动刷新班级池列表后提示成功 */
        async refreshAccounts() {
            const ok = await this.loadAccounts();
            if (ok) this.$message.success('刷新成功');
        },
        /** @returns {Promise<boolean>} 是否加载成功 */
        async loadWriteOffLedger() {
            if (!this.semesterId) return false;
            this.writeOffLoading = true;
            try {
                const woParams = {
                    schoolDepartmentId: this.schoolDepartmentId,
                    semesterId: this.semesterId,
                    ledgerType: 'PhysicalCoinWriteOff',
                    pageIndex: this.writeOffPage,
                    pageSize: this.writeOffPageSize,
                };
                if (Array.isArray(this.writeOffBizDateRange) && this.writeOffBizDateRange.length === 2
                    && this.writeOffBizDateRange[0] && this.writeOffBizDateRange[1]) {
                    woParams.bizDateStart = this.writeOffBizDateRange[0];
                    woParams.bizDateEnd = this.writeOffBizDateRange[1];
                }
                const res = await zheshangGetClassLedger(woParams);
                if (res && res.data && res.data.success) {
                    const d = res.data.response || {};
                    this.writeOffLedger = (d.data || []).filter(r => r.LedgerType === 'PhysicalCoinWriteOff' || r.LedgerType === 'PhysicalCoinWriteOffRevoke');
                    this.writeOffTotal = d.dataCount || 0;
                    return true;
                }
                return false;
            } catch {
                return false;
            } finally {
                this.writeOffLoading = false;
            }
        },
        async refreshWriteOffLedger() {
            const ok = await this.loadWriteOffLedger();
            if (ok) this.$message.success('刷新成功');
        },
        /** 实体币核销：日期区间变更后回到第一页并查询 */
        onWriteOffBizDateRangeChange() {
            this.writeOffPage = 1;
            this.loadWriteOffLedger();
        },
        /** 全校流水：业务日期区间变更后回到第一页并查询 */
        onLedgerBizDateRangeChange() {
            this.ledgerPage = 1;
            this.loadLedger();
        },
        /**
         * 组装全校流水查询/导出共用参数。
         * @param {{ pageIndex?: number, pageSize?: number }} extra 分页参数；导出可不传
         */
        buildLedgerQueryParams(extra = {}) {
            const params = {
                schoolDepartmentId: this.schoolDepartmentId,
                semesterId: this.semesterId,
                classId: this.ledgerClassFilter || 0,
                ...extra,
            };
            if (this.ledgerTypeFilter) params.ledgerType = this.ledgerTypeFilter;
            if (Array.isArray(this.ledgerBizDateRange) && this.ledgerBizDateRange.length === 2
                && this.ledgerBizDateRange[0] && this.ledgerBizDateRange[1]) {
                params.bizDateStart = this.ledgerBizDateRange[0];
                params.bizDateEnd = this.ledgerBizDateRange[1];
            }
            return params;
        },
        /** @returns {Promise<boolean>} 是否加载成功 */
        async loadLedger() {
            if (!this.semesterId) return false;
            this.ledgerLoading = true;
            try {
                const params = this.buildLedgerQueryParams({
                    pageIndex: this.ledgerPage,
                    pageSize: this.ledgerPageSize,
                });
                const res = await zheshangGetClassLedger(params);
                if (res && res.data && res.data.success) {
                    const d = res.data.response || {};
                    this.ledgerRows = d.data || [];
                    this.ledgerTotal = d.dataCount || 0;
                    return true;
                }
                return false;
            } catch {
                return false;
            } finally {
                this.ledgerLoading = false;
            }
        },
        async refreshLedger() {
            const ok = await this.loadLedger();
            if (ok) this.$message.success('刷新成功');
        },
        /** 全校流水：清空班级/类型/日期筛选并重新查询 */
        resetLedgerFilters() {
            this.ledgerClassFilter = null;
            this.ledgerTypeFilter = null;
            this.ledgerBizDateRange = null;
            this.ledgerPage = 1;
            this.loadLedger();
        },
        /**
         * 下载后台导出的 Excel。
         */
        downloadLedgerExcelBlob(data, fileName) {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        /**
         * 解析导出失败时的后端提示。
         */
        async parseLedgerExportError(data) {
            try {
                const text = await data.text();
                if (!text) return '导出失败';
                try {
                    const json = JSON.parse(text);
                    return json.msg || json.title || json.detail || '导出失败';
                } catch (e) {
                    return text;
                }
            } catch (e) {
                return '导出失败';
            }
        },
        /**
         * 导出当前筛选条件下的全校流水（后台 Excel）。
         */
        async exportLedger() {
            if (!this.zheshangEnabled) {
                this.$message.warning('当前校区未启用哲商模式');
                return;
            }
            if (!this.semesterId) {
                this.$message.warning('请先选择学期');
                return;
            }
            this.ledgerExporting = true;
            try {
                const params = this.buildLedgerQueryParams();
                const response = await zheshangExportClassLedger(params);
                if (!response.data) {
                    this.$message.error('导出数据为空');
                    return;
                }
                const mime = String((response.data && response.data.type) || '');
                if (mime && mime.indexOf('sheet') < 0 && mime.indexOf('octet-stream') < 0) {
                    const msg = await this.parseLedgerExportError(response.data);
                    this.$message.error(msg);
                    return;
                }
                this.downloadLedgerExcelBlob(response.data, `全校流水_${Date.now()}.xlsx`);
            } catch (e) {
                this.$message.error('导出出错');
            } finally {
                this.ledgerExporting = false;
            }
        },
        openGrantDialog() {
            if (!this.zheshangEnabled) {
                this.$message.warning('当前校区未启用哲商模式');
                return;
            }
            this.grantForm = { classIds: [], points: 100, remark: '', grantSourceTypeId: null };
            this.loadGrantSourceTypesEnabled();
            this.grantActivityType = 'normal';
            this.grantFlagSemesterId = this.semesterId;
            this.grantFlagWeekNumber = null;
            this.grantFlagWeeks = [];
            this.grantFlagMonth = null;
            this.grantDialogVisible = true;
            if (this.grantFlagSemesterId) this.loadGrantFlagWeeks();
        },
        onGrantActivityTypeChange() {
            this.grantForm.classIds = [];
            this.grantGradeId = null;
            this.grantGradeClasses = [];
            this.grantFlagWeekNumber = null;
            this.grantFlagMonth = null;
            this.grantFlagClasses = [];
            if (this.grantActivityType === 'weekFlag' && this.grantFlagSemesterId) {
                this.loadGrantFlagWeeks();
            }
        },
        /**
         * 本地日历 yyyy-mm-dd，用于学段周边界与「今天」比较。
         */
        moralLocalYmd(dateVal) {
            if (!dateVal) return '';
            const d = new Date(dateVal);
            if (isNaN(d.getTime())) return '';
            const pad = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        },
        /**
         * 根据当前日期默认「上一周」：在学周列表中，取「周结束日」严格早于本地今天、且结束日最晚的一周。
         */
        moralPickDefaultPrevWeekNumber(weeks) {
            if (!weeks || !weeks.length) return null;
            const todayKey = this.moralLocalYmd(new Date());
            let bestWeek = null;
            let bestEndKey = '';
            for (let i = 0; i < weeks.length; i++) {
                const w = weeks[i];
                const endKey = this.moralLocalYmd(w.EndDate);
                if (!endKey || endKey >= todayKey) continue;
                if (!bestWeek || endKey > bestEndKey) {
                    bestWeek = w;
                    bestEndKey = endKey;
                }
            }
            return bestWeek ? bestWeek.WeekNumber : null;
        },
        /** 查询模式「按月」默认：自然月上个月，yyyyMM */
        moralPrevCalendarMonthYyyyMm() {
            const d = new Date();
            d.setDate(1);
            d.setMonth(d.getMonth() - 1);
            const pad = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}${pad(d.getMonth() + 1)}`;
        },
        async loadGrantFlagWeeks() {
            this.grantFlagWeekNumber = null;
            this.grantFlagWeeks = [];
            if (!this.grantFlagSemesterId) return;
            try {
                const res = await adminGetSemesterWeeks({
                    semesterId: this.grantFlagSemesterId,
                });
                if (res && res.data && res.data.success) {
                    this.grantFlagWeeks = res.data.response || [];
                    this.grantFlagWeekNumber = this.moralPickDefaultPrevWeekNumber(this.grantFlagWeeks);
                }
            } catch { /* ignore */ }
        },
        async autoSelectFlagClasses() {
            if (!this.schoolDepartmentId) return;
            if (this.grantActivityType === 'weekFlag' && !this.grantFlagSemesterId) {
                this.$message.warning('请先选择学期');
                return;
            }
            if (this.grantActivityType === 'monthFlag' && !this.grantFlagMonth) {
                this.$message.warning('请先选择月份');
                return;
            }
            this.grantFlagLoading = true;
            try {
                const params = {
                    schoolDepartmentId: this.schoolDepartmentId,
                    gradeId: 0,
                };
                if (this.grantActivityType === 'weekFlag') {
                    params.semesterId = this.grantFlagSemesterId;
                    params.weekNumber = this.grantFlagWeekNumber || -1;
                } else {
                    params.periodMonth = this.grantFlagMonth;
                }
                const pageChunk = 200;
                let page = 1;
                let allRows = [];
                let totalCount = 0;
                // 分页拉全量班级榜（接口单次最多 200 条）
                while (true) {
                    const res = await adminGetFlagRecords({ ...params, pageIndex: page, pageSize: pageChunk });
                    if (!res || !res.data || !res.data.success) {
                        this.$message.error((res && res.data && res.data.msg) || '获取红旗班级失败');
                        return;
                    }
                    const pack = res.data.response || {};
                    const chunk = pack.data || [];
                    totalCount = pack.dataCount || 0;
                    allRows = allRows.concat(chunk);
                    if (allRows.length >= totalCount || chunk.length < pageChunk) break;
                    page += 1;
                    if (page > 200) break;
                }
                const knownMap = new Map(this.classDepts.map(d => [d.Id, d]));
                const flagClasses = allRows
                    .filter(r => r.FlagCount > 0 && knownMap.has(r.DepartmentId))
                    .map(r => knownMap.get(r.DepartmentId));
                if (flagClasses.length === 0) {
                    this.$message.info('该时段暂无流动红旗记录');
                    this.grantFlagClasses = [];
                    this.grantForm.classIds = [];
                } else {
                    this.grantFlagClasses = flagClasses;
                    this.grantForm.classIds = flagClasses.map(d => d.Id);
                    this.$message.success(`已自动选取 ${flagClasses.length} 个红旗班级`);
                    // 自动填充备注
                    if (!this.grantForm.remark) {
                        if (this.grantActivityType === 'weekFlag' && this.grantFlagWeekNumber) {
                            const wk = this.grantFlagWeeks.find(w => w.WeekNumber === this.grantFlagWeekNumber);
                            this.grantForm.remark = wk ? `荣获${wk.Label}流动红旗` : '荣获本周流动红旗';
                        } else if (this.grantActivityType === 'monthFlag' && this.grantFlagMonth) {
                            this.grantForm.remark = `荣获${this.grantFlagMonth}月流动红旗`;
                        }
                    }
                }
            } catch {
                this.$message.error('获取失败，请重试');
            } finally {
                this.grantFlagLoading = false;
            }
        },
        resetGrantForm() {
            this.$refs.grantFormRef && this.$refs.grantFormRef.resetFields();
            this.grantGradeId = null;
            this.grantGradeClasses = [];
            this.grantActivityType = 'normal';
            this.grantFlagSemesterId = null;
            this.grantFlagWeekNumber = null;
            this.grantFlagWeeks = [];
            this.grantFlagMonth = null;
            this.grantFlagClasses = [];
        },
        submitGrant() {
            this.$refs.grantFormRef.validate(async valid => {
                if (!valid) return;
                if (this.grantForm.classIds.length === 0) {
                    this.$message.warning('请选择至少一个班级');
                    return;
                }
                this.grantSubmitting = true;
                try {
                    const res = await zheshangAdminBatchGrantClassPool({
                        schoolDepartmentId: this.schoolDepartmentId,
                        classIds: this.grantForm.classIds,
                        semesterId: this.semesterId,
                        points: this.grantForm.points,
                        remark: this.grantForm.remark,
                        grantSourceTypeId: this.grantForm.grantSourceTypeId,
                    });
                    if (res && res.data && res.data.success) {
                        const d = res.data.response || {};
                        const failCount = (d.FailedClassIds || []).length;
                        if (failCount === 0) {
                            this.$message.success(res.data.msg || '发放成功');
                        } else {
                            this.$message.warning(res.data.msg || `部分班级发放失败（${failCount} 班）`);
                        }
                        this.grantDialogVisible = false;
                        this.loadAccounts();
                        this.loadLedger();
                    } else {
                        this.$message.error((res && res.data && res.data.msg) || '发放失败');
                    }
                } catch { this.$message.error('发放失败，请重试'); }
                finally { this.grantSubmitting = false; }
            });
        },
        async loadGrantSourceTypesEnabled() {
            if (!this.schoolDepartmentId || !this.zheshangEnabled) {
                this.grantSourceTypesEnabled = [];
                return;
            }
            try {
                const res = await zheshangGetGrantSourceTypes({
                    schoolDepartmentId: this.schoolDepartmentId,
                    enabledOnly: true,
                });
                if (res && res.data && res.data.success) {
                    this.grantSourceTypesEnabled = res.data.response || [];
                } else {
                    this.grantSourceTypesEnabled = [];
                }
            } catch {
                this.grantSourceTypesEnabled = [];
            }
        },
        openGrantSourceTypeDialog() {
            if (!this.schoolDepartmentId) {
                this.$message.warning('请先在左侧选择学校');
                return;
            }
            if (!this.zheshangEnabled) {
                this.$message.warning('当前校区未启用哲商模式');
                return;
            }
            this.grantSourceTypePage = 1;
            this.grantSourceTypeDialogVisible = true;
        },
        onGrantSourceTypePageChange(page) {
            this.grantSourceTypePage = page;
        },
        async loadGrantSourceTypesAll() {
            if (!this.schoolDepartmentId || !this.zheshangEnabled) {
                this.grantSourceTypesAll = [];
                return;
            }
            this.grantSourceTypeLoading = true;
            try {
                const res = await zheshangGetGrantSourceTypes({
                    schoolDepartmentId: this.schoolDepartmentId,
                    enabledOnly: false,
                });
                if (res && res.data && res.data.success) {
                    this.grantSourceTypesAll = res.data.response || [];
                    const maxPage = Math.max(1, Math.ceil(this.grantSourceTypesAll.length / this.grantSourceTypePageSize));
                    if (this.grantSourceTypePage > maxPage) {
                        this.grantSourceTypePage = maxPage;
                    }
                } else {
                    this.grantSourceTypesAll = [];
                    this.grantSourceTypePage = 1;
                }
            } catch {
                this.grantSourceTypesAll = [];
                this.grantSourceTypePage = 1;
                this.$message.error('加载来源类型失败');
            } finally {
                this.grantSourceTypeLoading = false;
            }
        },
        openGrantSourceTypeEdit(row) {
            if (row) {
                this.grantSourceTypeEditForm = {
                    Id: row.Id,
                    Name: row.Name,
                    SortOrder: row.SortOrder,
                    Color: row.Color || '',
                    Enabled: row.Enabled,
                };
            } else {
                const maxSort = (this.grantSourceTypesAll || []).reduce((m, t) => Math.max(m, t.SortOrder || 0), 0);
                this.grantSourceTypeEditForm = {
                    Id: 0,
                    Name: '',
                    SortOrder: maxSort + 1,
                    Color: '',
                    Enabled: true,
                };
            }
            this.grantSourceTypeEditVisible = true;
        },
        async submitGrantSourceTypeEdit() {
            this.$refs.grantSourceTypeEditRef.validate(async valid => {
                if (!valid) return;
                this.grantSourceTypeSaving = true;
                try {
                    const f = this.grantSourceTypeEditForm;
                    const res = await zheshangSaveGrantSourceType({
                        id: f.Id,
                        schoolDepartmentId: this.schoolDepartmentId,
                        name: f.Name,
                        sortOrder: f.SortOrder,
                        color: f.Color,
                        enabled: f.Enabled,
                    });
                    if (res && res.data && res.data.success) {
                        this.$message.success('保存成功');
                        this.grantSourceTypeEditVisible = false;
                        await this.loadGrantSourceTypesAll();
                        await this.loadGrantSourceTypesEnabled();
                    } else {
                        this.$message.error((res && res.data && res.data.msg) || '保存失败');
                    }
                } catch {
                    this.$message.error('保存失败');
                } finally {
                    this.grantSourceTypeSaving = false;
                }
            });
        },
        /** 一键导入预设来源类型（跳过已存在同名项） */
        initDefaultGrantSourceTypes() {
            if (!this.schoolDepartmentId) {
                this.$message.warning('请先在左侧选择学校');
                return;
            }
            const existingNames = new Set((this.grantSourceTypesAll || []).map(t => (t.Name || '').trim()));
            const toCreate = DEFAULT_GRANT_SOURCE_TYPE_PRESETS.filter(p => !existingNames.has(p.name));
            if (toCreate.length === 0) {
                this.$message.info('默认类型已全部存在，无需重复初始化');
                return;
            }
            this.grantSourceTypeInitPending = toCreate;
            this.grantSourceTypeInitConfirmVisible = true;
        },
        async confirmInitDefaultGrantSourceTypes() {
            const toCreate = this.grantSourceTypeInitPending || [];
            if (toCreate.length === 0) {
                this.grantSourceTypeInitConfirmVisible = false;
                return;
            }
            this.grantSourceTypeInitLoading = true;
            let successCount = 0;
            try {
                for (const preset of toCreate) {
                    const res = await zheshangSaveGrantSourceType({
                        id: 0,
                        schoolDepartmentId: this.schoolDepartmentId,
                        name: preset.name,
                        sortOrder: preset.sortOrder,
                        color: preset.color,
                        enabled: true,
                    });
                    if (res && res.data && res.data.success) {
                        successCount++;
                    } else {
                        this.$message.error((res && res.data && res.data.msg) || `「${preset.name}」创建失败`);
                    }
                }
                if (successCount > 0) {
                    this.$message.success(`已初始化 ${successCount} 项默认来源类型`);
                    this.grantSourceTypeInitConfirmVisible = false;
                    this.grantSourceTypeInitPending = [];
                    await this.loadGrantSourceTypesAll();
                    await this.loadGrantSourceTypesEnabled();
                }
            } catch {
                this.$message.error('初始化失败，请重试');
            } finally {
                this.grantSourceTypeInitLoading = false;
            }
        },
        async toggleGrantSourceTypeEnabled(row) {
            try {
                const res = await zheshangSaveGrantSourceType({
                    id: row.Id,
                    schoolDepartmentId: this.schoolDepartmentId,
                    name: row.Name,
                    sortOrder: row.SortOrder,
                    color: row.Color,
                    enabled: !row.Enabled,
                });
                if (res && res.data && res.data.success) {
                    this.$message.success(row.Enabled ? '已禁用' : '已启用');
                    await this.loadGrantSourceTypesAll();
                    await this.loadGrantSourceTypesEnabled();
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '操作失败');
                }
            } catch {
                this.$message.error('操作失败');
            }
        },
        openWriteOffDialog() {
            if (!this.zheshangEnabled) {
                this.$message.warning('当前校区未启用哲商模式');
                return;
            }
            this.writeOffForm = { classId: null, points: 1, physicalCoinCount: null, remark: '' };
            this.writeOffAccountRow = null;
            this.writeOffDialogVisible = true;
        },
        resetWriteOffForm() {
            this.$refs.writeOffFormRef && this.$refs.writeOffFormRef.resetFields();
            this.writeOffGradeId = null;
            this.writeOffGradeClasses = [];
            this.writeOffAccountRow = null;
            this.writeOffAccountLoading = false;
        },
        submitWriteOff() {
            this.$refs.writeOffFormRef.validate(async valid => {
                if (!valid) return;
                const h = this.writeOffPoolHint;
                if (h) {
                    if (h.redeemable <= 0) {
                        this.$message.warning('可兑币分为 0，无法核销');
                        return;
                    }
                    if (Number(this.writeOffForm.points) > h.redeemable) {
                        this.$message.warning(`扣除分值不能大于可兑币分（当前 ${h.redeemable}）`);
                        return;
                    }
                }
                this.writeOffSubmitting = true;
                try {
                    const res = await zheshangWriteOffPhysicalCoin({
                        schoolDepartmentId: this.schoolDepartmentId,
                        classId: this.writeOffForm.classId,
                        semesterId: this.semesterId,
                        points: this.writeOffForm.points,
                        physicalCoinCount: this.writeOffForm.physicalCoinCount || null,
                        remark: this.writeOffForm.remark || '',
                        operatorRole: 'admin',
                    });
                    if (res && res.data && res.data.success) {
                        this.$message.success('核销成功');
                        this.writeOffDialogVisible = false;
                        this.loadAccounts();
                        this.loadWriteOffLedger();
                        this.loadLedger();
                    } else {
                        this.$message.error((res && res.data && res.data.msg) || '核销失败');
                    }
                } catch { this.$message.error('核销失败，请重试'); }
                finally { this.writeOffSubmitting = false; }
            });
        },
        /** 根据流水 AccountId 匹配班级池概要（与 zheshangGetClassAccounts 返回项一致，用于剩余可用判断） */
        moralPoolAccountByLedgerAccountId(accountId) {
            if (accountId == null || accountId === '' || !this.accounts || !this.accounts.length) return null;
            const idStr = String(accountId);
            return this.accounts.find(a => String(a.AccountId != null ? a.AccountId : a.accountId) === idStr) || null;
        },
        /** 撤回管理员发放所需「剩余可用」门槛（与后端 AdminRevokeGrant：AvailableBalance >= 原发放 DeltaPoints） */
        moralAdminRevokeNeededAvailable(row) {
            return Math.max(0, this.pickNumField(row, 'deltaPoints', 'DeltaPoints'));
        },
        /** 撤回实体币核销时恢复的德育分值（= |核销流水 DeltaPoints|），仅加回可兑余额 */
        moralRevokeWriteOffRestorePoints(row) {
            return Math.abs(this.pickNumField(row, 'deltaPoints', 'DeltaPoints'));
        },
        /** 管理员发放：已有撤回流水则不显示撤回；剩余可用不足也不显示（与后端余额校验一致） */
        canShowAdminGrantRevoke(row) {
            if (!row || row.LedgerType !== 'AdminGrant') return false;
            var p = row.AdminGrantAlreadyRevoked;
            var revoked = (p === undefined || p === null) ? row.adminGrantAlreadyRevoked : p;
            if (revoked === true) return false;
            const need = this.moralAdminRevokeNeededAvailable(row);
            if (need <= 0) return false;
            const acct = this.moralPoolAccountByLedgerAccountId(row.AccountId != null ? row.AccountId : row.accountId);
            if (!acct) return true;
            const avail = this.pickNumField(acct, 'availableBalance', 'AvailableBalance');
            return avail >= need;
        },
        /** 实体币核销：未撤回则显示撤回（后端仅恢复可兑余额，不扣班级池剩余） */
        canShowPhysicalCoinWriteOffRevoke(row) {
            if (!row || row.LedgerType !== 'PhysicalCoinWriteOff') return false;
            var p = row.PhysicalCoinWriteOffAlreadyRevoked;
            var revoked = (p === undefined || p === null) ? row.physicalCoinWriteOffAlreadyRevoked : p;
            if (revoked === true) return false;
            return this.moralRevokeWriteOffRestorePoints(row) > 0;
        },
        async revokeGrant(row) {
            await this.loadAccounts();
            const need = this.moralAdminRevokeNeededAvailable(row);
            const acct = this.moralPoolAccountByLedgerAccountId(row.AccountId != null ? row.AccountId : row.accountId);
            const avail = acct ? this.pickNumField(acct, 'availableBalance', 'AvailableBalance') : null;
            if (acct != null && avail != null && avail < need) {
                this.$message.warning(
                    `班级池剩余可用不足（当前剩余 ${this.formatIssuedNum(avail)}，撤回需扣减 ${this.formatIssuedNum(need)}），无法撤回。`
                );
                return;
            }
            try {
                const extra = acct != null && avail != null ? `当前班级池剩余可用：${this.formatIssuedNum(avail)}；撤回将扣减：${this.formatIssuedNum(need)}。` : '';
                await this.$confirm(
                    `确认撤回该笔管理员发放？撤回后对应班级池「剩余可用」将减少。${extra}`,
                    '撤回确认',
                    { type: 'warning', confirmButtonText: '确定撤回', cancelButtonText: '取消' }
                );
            } catch {
                return;
            }
            try {
                const res = await zheshangAdminRevokeGrant({
                    originalLedgerId: row.Id,
                    operatorRole: 'admin',
                });
                if (res && res.data && res.data.success) {
                    this.$message.success('撤回成功');
                    this.loadAccounts();
                    this.loadLedger();
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '撤回失败');
                }
            } catch { this.$message.error('撤回失败，请重试'); }
        },
        async revokeWriteOff(row) {
            await this.loadAccounts();
            const restore = this.moralRevokeWriteOffRestorePoints(row);
            try {
                await this.$confirm(
                    this.zheshangEvalUsesTeacherLimit
                        ? `确认撤回该笔实体币核销？将恢复班级池剩余 ${this.formatIssuedNum(restore)} 分。`
                        : `确认撤回该笔实体币核销？将恢复可兑余额 ${this.formatIssuedNum(restore)} 分；班级池剩余（可用）不变。`,
                    '撤回确认',
                    { type: 'warning', confirmButtonText: '确定撤回', cancelButtonText: '取消' }
                );
            } catch {
                return;
            }
            try {
                const res = await zheshangRevokeWriteOff({
                    originalLedgerId: row.Id,
                    operatorRole: 'admin',
                });
                if (res && res.data && res.data.success) {
                    this.$message.success('撤回成功');
                    this.loadAccounts();
                    this.loadWriteOffLedger();
                    this.loadLedger();
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '撤回失败');
                }
            } catch { this.$message.error('撤回失败，请重试'); }
        },
        formatTime(val) {
            if (!val) return '-';
            const d = new Date(val);
            if (isNaN(d.getTime())) return val;
            const pad = n => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        /** 兼容 camelCase / PascalCase 数值字段 */
        pickNumField(row, camelKey, pascalKey) {
            if (!row) return 0;
            const raw = row[camelKey] != null && row[camelKey] !== '' ? row[camelKey] : row[pascalKey];
            const x = Number(raw);
            return Number.isFinite(x) ? x : 0;
        },
        /** 可兑净额（含核销），即 IssuedToStudents；旧哲商模式用 */
        poolRowIssuedNet(row) {
            return this.pickNumField(row, 'issuedToStudents', 'IssuedToStudents');
        },
        /**
         * 实体币可兑/可换币余额。新模式优先 PhysicalCoinRedeemablePoints（=班级池剩余）。
         * 创建于 2026-03-16
         */
        poolRowRedeemable(row) {
            if (!row) return 0;
            const hasRedeemableField = Object.prototype.hasOwnProperty.call(row, 'PhysicalCoinRedeemablePoints')
                || Object.prototype.hasOwnProperty.call(row, 'physicalCoinRedeemablePoints');
            if (hasRedeemableField) {
                return this.pickNumField(row, 'physicalCoinRedeemablePoints', 'PhysicalCoinRedeemablePoints');
            }
            if (this.zheshangEvalUsesTeacherLimit) {
                return this.pickNumField(row, 'availableBalance', 'AvailableBalance');
            }
            return this.poolRowIssuedNet(row);
        },
        /**
         * 发分与点评累计：发分/点评流水合计，不含实体币核销净影响（与接口 IssuedToStudentsGross 一致）。
         */
        poolRowIssuedGross(row) {
            if (!row) return 0;
            if (Object.prototype.hasOwnProperty.call(row, 'IssuedToStudentsGross')
                || Object.prototype.hasOwnProperty.call(row, 'issuedToStudentsGross'))
                return this.pickNumField(row, 'issuedToStudentsGross', 'IssuedToStudentsGross');
            const net = this.poolRowIssuedNet(row);
            const wo = this.pickNumField(row, 'issuedDetailWriteOffNet', 'IssuedDetailWriteOffNet');
            return net - wo;
        },
        /** 已发构成展示：去掉多余小数 */
        formatIssuedNum(v) {
            const x = Number(v);
            if (!Number.isFinite(x)) return '0';
            if (Math.abs(x - Math.round(x)) < 1e-6) return String(Math.round(x));
            return String(Math.round(x * 100) / 100);
        },
        /**
         * 划拨任课净额：按「还剩 = 下发 + 划拨 + 班主任直发/点评扣池」反推，保证与可换币一致。
         * 创建于 2026-11-02
         */
        poolTeacherAllotNet(row) {
            if (!row) return 0;
            const totalGranted = this.pickNumField(row, 'totalGranted', 'TotalGranted');
            const poolRemain = this.pickNumField(row, 'availableBalance', 'AvailableBalance');
            const homeroomGrant = this.pickNumField(row, 'issuedDetailHomeroomGrant', 'IssuedDetailHomeroomGrant');
            const homeroomEval = this.pickNumField(row, 'issuedDetailHomeroomEvaluation', 'IssuedDetailHomeroomEvaluation');
            // Available = TotalGranted + AllotNet - HomeroomGrant - HomeroomEval
            return poolRemain - totalGranted + homeroomGrant + homeroomEval;
        },
        /** 加减表带符号展示 */
        formatPoolCalcSigned(n) {
            const x = Number(n);
            if (!Number.isFinite(x) || Math.abs(x) < 1e-9) return '0';
            const body = this.formatIssuedNum(Math.abs(x));
            return x > 0 ? `+${body}` : `-${body}`;
        },
        /**
         * 新模式：班级池剩余构成（一张加减表）。创建于 2026-11-02
         */
        poolRemainingBreakdownItems(row) {
            if (!row) return [];
            const totalGranted = this.pickNumField(row, 'totalGranted', 'TotalGranted');
            const allotNet = this.poolTeacherAllotNet(row);
            const homeroomGrantPool = -this.pickNumField(row, 'issuedDetailHomeroomGrant', 'IssuedDetailHomeroomGrant');
            const homeroomEvalPool = -this.pickNumField(row, 'issuedDetailHomeroomEvaluation', 'IssuedDetailHomeroomEvaluation');
            const poolRemain = this.pickNumField(row, 'availableBalance', 'AvailableBalance');
            const mk = (k, n, total) => ({ k, n, v: this.formatIssuedNum(n), total: !!total });
            return [
                mk('学校已下发', totalGranted),
                mk('划拨给任课', allotNet),
                mk('班主任直发', homeroomGrantPool),
                mk('班主任点评', homeroomEvalPool),
                mk('还剩可换币', poolRemain, true),
            ];
        },
        /** 展开/收起历史发分。创建于 2026-11-02 */
        toggleIssuedHistory() {
            const open = this.issuedBreakdownCollapse.indexOf('issued') >= 0;
            this.issuedBreakdownCollapse = open ? [] : ['issued'];
        },
        /** 关闭构成弹窗时清空状态 */
        onIssuedBreakdownDialogClose() {
            this.issuedBreakdownContextRow = null;
            this.issuedBreakdownCollapse = [];
        },
        /** 悬浮层：已发给学生按流水类型汇总（含数值 n 供正负样式） */
        issuedBreakdownItems(row) {
            if (!row) return [];
            const item = (label, camelKey, pascalKey) => {
                const n = this.pickNumField(row, camelKey, pascalKey);
                return { k: label, n, v: this.formatIssuedNum(n) };
            };
            return [
                item('班主任直发', 'issuedDetailHomeroomGrant', 'IssuedDetailHomeroomGrant'),
                item('任课发分', 'issuedDetailSubjectGrant', 'IssuedDetailSubjectGrant'),
                item('班主任点评', 'issuedDetailHomeroomEvaluation', 'IssuedDetailHomeroomEvaluation'),
                item('任课点评', 'issuedDetailSubjectEvaluation', 'IssuedDetailSubjectEvaluation'),
                item('核销净影响', 'issuedDetailWriteOffNet', 'IssuedDetailWriteOffNet'),
                item('未归类', 'issuedDetailOther', 'IssuedDetailOther'),
            ];
        },
        /** 构成项数值：正绿 / 负红 / 零灰 */
        issuedValToneClass(n) {
            const x = Number(n);
            if (!Number.isFinite(x) || x === 0) return 'issued-val-zero';
            if (x > 0) return 'issued-val-pos';
            return 'issued-val-neg';
        },
        /** 与账户差展示（兼容 camel / Pascal） */
        issuedBreakdownDiffText(row) {
            const d = this.pickNumField(row, 'issuedBreakdownReconciliationDiff', 'IssuedBreakdownReconciliationDiff');
            return this.formatIssuedNum(d);
        },
        /**
         * 打开可兑分项构成弹窗。kind：pool / rank（预留，标题统一）。
         */
        openIssuedBreakdownDialog(row, kind) {
            if (!row) return;
            this.issuedBreakdownContextRow = row;
            const cn = String((row.ClassName != null ? row.ClassName : row.className) || '').trim();
            const suffix = cn ? `（${cn}）` : '';
            this.issuedBreakdownCollapse = [];
            this.issuedBreakdownDialogTitle = this.zheshangEvalUsesTeacherLimit
                ? `现在可换币说明${suffix}`
                : `可兑分项构成${suffix}`;
            this.issuedBreakdownDialogVisible = true;
        },
        /** 任课额度明细表：表头与单元格居中 */
        teacherQuotaTableCellStyle() {
            return { textAlign: 'center' };
        },
        /** 关闭任课额度明细弹窗时清空状态 */
        resetTeacherQuotaDetailDialog() {
            this.teacherQuotaSummaryRow = null;
            this.teacherQuotaDetailTeachers = [];
            this.teacherQuotaDetailStale = false;
            this.teacherQuotaDetailLoading = false;
        },
        /**
         * 打开任课额度按教师明细（调用 GetClassTeacherQuotas，与班主任工作台同源）
         */
        async openTeacherQuotaDetailDialog(row) {
            if (!row) return;
            const classId = row.ClassId != null ? row.ClassId : row.classId;
            if (!this.schoolDepartmentId || !classId) {
                this.$message.warning('缺少学校或班级信息');
                return;
            }
            if (!this.semesterId) {
                this.$message.warning('请先选择学期');
                return;
            }
            this.teacherQuotaSummaryRow = row;
            const cn = String((row.ClassName != null ? row.ClassName : row.className) || '').trim();
            const titleBase = this.zheshangEvalUsesTeacherLimit ? '历史任课额度' : '任课额度明细';
            this.teacherQuotaDialogTitle = cn ? `${titleBase}（${cn}）` : titleBase;
            this.teacherQuotaDialogVisible = true;
            this.teacherQuotaDetailLoading = true;
            this.teacherQuotaDetailTeachers = [];
            this.teacherQuotaDetailStale = false;
            try {
                const res = await zheshangGetClassTeacherQuotas({
                    schoolDepartmentId: this.schoolDepartmentId,
                    classId,
                    semesterId: this.semesterId,
                });
                if (res && res.data && res.data.success) {
                    const pack = res.data.response || {};
                    const list = pack.teachers || pack.Teachers || [];
                    this.teacherQuotaDetailTeachers = Array.isArray(list) ? list : [];
                    let staleRaw = pack.hasStaleQuotaRecordsFromDepartedTeachers;
                    if (staleRaw === undefined || staleRaw === null) {
                        staleRaw = pack.HasStaleQuotaRecordsFromDepartedTeachers;
                    }
                    this.teacherQuotaDetailStale = staleRaw === true;
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '加载任课额度失败');
                    this.teacherQuotaDialogVisible = false;
                }
            } catch {
                this.$message.error('加载任课额度失败，请重试');
                this.teacherQuotaDialogVisible = false;
            } finally {
                this.teacherQuotaDetailLoading = false;
            }
        },
        issuedBreakdownShowDiff(row) {
            // 新模式下可换币=班级池剩余，旧「与账户差」无对照意义，不展示
            if (this.zheshangEvalUsesTeacherLimit) return false;
            const d = this.pickNumField(row, 'issuedBreakdownReconciliationDiff', 'IssuedBreakdownReconciliationDiff');
            return Math.abs(d) >= 0.01;
        },
        /**
         * 流水操作人展示：结合 OperatorRole 区分管理员 / 班主任 / 任课（发给学生时依赖此前端字段）。
         */
        ledgerOperatorDisplay(row) {
            if (!row) return '—';
            const role = String(row.OperatorRole || '').toLowerCase();
            const name = (row.OperatorName && String(row.OperatorName).trim()) || '';
            if (role === 'admin') return name ? `${name}（管理员）` : '管理员';
            if (role === 'homeroom') return name ? `${name}（班主任）` : '班主任';
            if (role === 'subject') return name ? `${name}（任课）` : '任课教师';
            return name || '—';
        },
        /** 流水类型标签色（仍按英文 LedgerType 判断，与接口无关） */
        ledgerTypeTagType(type) {
            if (type === 'AdminGrant') return 'success';
            if (type && type.includes('Revoke')) return 'danger';
            if (type === 'PhysicalCoinWriteOff') return 'warning';
            return 'info';
        },
        // ── 流动红旗查询方法 ──
        async onFlagModeChange() {
            this.flagTableData = [];
            this.flagPage = 1;
            this.flagTotal = 0;
            if (this.flagPeriodMode === 0) {
                this.flagPeriodMonth = null;
                if (this.flagSemesterId)
                    await this.loadFlagWeeks();
                else {
                    this.flagWeekNumber = null;
                    this.flagWeeks = [];
                }
            } else {
                this.flagWeekNumber = null;
                this.flagWeeks = [];
                this.flagPeriodMonth = this.moralPrevCalendarMonthYyyyMm();
            }
            if (this.pageTab === 'flag')
                this.$nextTick(() => this.tryAutoLoadFlagData());
        },
        async onFlagSemesterChange(clearData) {
            if (clearData) {
                this.flagWeekNumber = null;
                this.flagWeeks = [];
                this.flagTableData = [];
                this.flagPage = 1;
                this.flagTotal = 0;
            }
            await this.loadFlagWeeks();
            if (this.pageTab === 'flag')
                this.$nextTick(() => this.tryAutoLoadFlagData());
        },
        async loadFlagWeeks() {
            this.flagWeekNumber = null;
            this.flagWeeks = [];
            if (!this.flagSemesterId) return;
            try {
                const res = await adminGetSemesterWeeks({
                    semesterId: this.flagSemesterId,
                });
                if (res && res.data && res.data.success) {
                    this.flagWeeks = res.data.response || [];
                    this.flagWeekNumber = this.moralPickDefaultPrevWeekNumber(this.flagWeeks);
                }
            } catch { /* ignore */ }
        },
        /**
         * 进入「流动红旗查询」分页或学期就绪后静默拉一次（条件不全则不请求、无提示）。
         */
        tryAutoLoadFlagData() {
            if (!this.schoolDepartmentId) return;
            if (this.flagPeriodMode === 0 && !this.flagSemesterId) return;
            if (this.flagPeriodMode === 1 && !this.flagPeriodMonth) return;
            this.flagPage = 1;
            this.loadFlagData({ silentPrecheck: true });
        },
        /**
         * @param {{ silentPrecheck?: boolean }} [opts] — 自动触发时跳过「请先选择」类提示。
         */
        /** 查询条件变更：回到第 1 页并请求 */
        flagQueryBarChange() {
            this.flagPage = 1;
            this.loadFlagData();
        },
        /** 仅翻页 */
        onFlagPageChange(p) {
            this.flagPage = p;
            this.loadFlagData();
        },
        async loadFlagData(opts) {
            const silent = opts && opts.silentPrecheck;
            if (!this.schoolDepartmentId) return;
            if (this.flagPeriodMode === 0 && !this.flagSemesterId) {
                if (!silent) this.$message.warning('请先选择学期');
                return;
            }
            if (this.flagPeriodMode === 1 && !this.flagPeriodMonth) {
                if (!silent) this.$message.warning('请选择月份');
                return;
            }
            this.flagLoading = true;
            try {
                const params = {
                    schoolDepartmentId: this.schoolDepartmentId,
                    gradeId: this.flagGradeId || 0,
                    pageIndex: this.flagPage,
                    pageSize: this.flagPageSize,
                };
                if (this.flagPeriodMode === 0) {
                    params.semesterId = this.flagSemesterId;
                    params.weekNumber = this.flagWeekNumber || -1;
                } else {
                    params.periodMonth = this.flagPeriodMonth;
                }
                const res = await adminGetFlagRecords(params);
                if (res && res.data && res.data.success) {
                    const pack = res.data.response || {};
                    this.flagTableData = pack.data || [];
                    this.flagTotal = pack.dataCount || 0;
                    if (pack.page) this.flagPage = pack.page;
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '查询失败');
                }
            } catch {
                this.$message.error('查询失败，请重试');
            } finally {
                this.flagLoading = false;
            }
        },
        /** 流动红旗分值展示（明细列 / 悬浮层） */
        flagFormatScore(v) {
            if (v === null || v === undefined || v === '') return '—';
            const n = Number(v);
            if (isNaN(n)) return String(v);
            if (Math.abs(n - Math.round(n)) < 1e-6) return String(Math.round(n));
            const t = n.toFixed(2).replace(/\.?0+$/, '');
            return t;
        },
        flagShortDatetime(s) {
            if (!s) return '';
            return String(s).replace('T', ' ').slice(0, 16);
        },
        flagShortDateRange(start, end) {
            const a = this.flagShortDatetime(start).slice(0, 10);
            const b = this.flagShortDatetime(end).slice(0, 10);
            if (a && b) return `${a} ～ ${b}`;
            return a || b || '';
        },
        flagSummaryCardClass(w) {
            if (!w) return '';
            if (w.IsCanceled) return 'is-canceled';
            if (w.IsManualAward) return 'is-manual';
            return 'is-normal';
        },
        openFlagDetailDialog(classRow, week) {
            this.flagDetailClass = classRow;
            this.flagDetailWeek = week;
            this.flagDetailVisible = true;
        },
        resetFlagDetailDialog() {
            this.flagDetailClass = null;
            this.flagDetailWeek = null;
        },
    },
};
</script>

<style scoped>
/* 交给全局 dp-layout 铺满；右栏禁止外滚。最后更新：2026-09-13 */
.no-dept-tip {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 14px;
}

.page-tabs {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.page-tabs >>> .el-tabs__header {
    flex-shrink: 0;
}

.page-tabs >>> .el-tabs__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.page-tabs >>> .el-tab-pane {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.top-bar {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 12px;
    flex: 0 0 auto;
}

.top-label {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
}

.top-dept {
    font-size: 13px;
    color: #606266;
    margin-left: 16px;
}

.main-tabs {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.main-tabs >>> .el-tabs__header {
    flex-shrink: 0;
}

.main-tabs >>> .el-tabs__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.main-tabs >>> .el-tab-pane {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.zheshang-mode-alert {
    margin: 0 0 12px;
    flex: 0 0 auto;
}

.main-tabs--disabled .issued-bd-chip,
.main-tabs--disabled .teacher-quota-chip,
.main-tabs--disabled .issued-bd-ref--click {
    pointer-events: none;
    opacity: 0.55;
    cursor: not-allowed;
}

.tab-toolbar {
    margin-bottom: 12px;
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    flex: 0 0 auto;
}

.toolbar-field-label {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
}

.tbl-scroll-host {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    overflow: hidden;
}

/* daterange：中间分隔符（至 / ~）区域过窄时上下或左右被裁切 */
.tab-toolbar ::v-deep .el-range-editor.el-input__inner {
    align-items: center;
}

.tab-toolbar ::v-deep .el-range-editor .el-range-separator {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 1.25em;
    padding: 0 6px;
    line-height: 32px;
    height: 32px;
    overflow: visible !important;
    white-space: nowrap;
    box-sizing: border-box;
    align-self: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* 占满工具栏剩余宽度，避免 max-width 导致右侧空一大块仍换行 */
.pool-hint-text {
    flex: 1 1 0;
    min-width: 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.45;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 「构成」入口：轻量标签（不用 el-button，避免 type=text 清掉背景） */
.issued-bd-chip {
    display: inline-block;
    padding: 0 8px;
    margin-left: 6px;
    vertical-align: middle;
    height: 22px;
    line-height: 20px;
    font-size: 12px;
    color: var(--btn-primary, #2563eb);
    background: #ecf5ff;
    border-radius: 4px;
    border: 1px solid #d9ecff;
    cursor: pointer;
    box-sizing: border-box;
}

.issued-bd-chip:hover {
    color: #66b1ff;
    background: #d9ecff;
    border-color: #c6e2ff;
}

/* 避免焦点环被看成黑粗框（含部分浏览器用 box-shadow 画 focus ring） */
.issued-bd-chip:focus,
.issued-bd-chip:focus-visible,
.issued-bd-chip:active {
    outline: none !important;
    box-shadow: none !important;
}

.quota-slash {
    color: #c0c4cc;
    margin: 0 4px;
}

.teacher-quota-chip {
    margin-left: 6px;
}

/* 班级池 / 排行：发分点评累计与可兑余额（表头与单元格） */
.moral-pool-issued-head {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1.25;
    gap: 2px;
    padding: 2px 0;
}

.moral-pool-issued-head-main {
    font-size: 12px;
    font-weight: 600;
    color: #303133;
}

.moral-pool-issued-head-sub {
    font-size: 11px;
    font-weight: 400;
    color: #909399;
}

/* 与「任课 · 已用/剩余」一致：累计/可兑单行展示 */
.moral-pool-slash-cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0;
    font-size: 13px;
}

.moral-pool-issued-v--gross {
    color: var(--btn-primary, #2563eb);
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.moral-pool-issued-v--net {
    color: #e6a23c;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.issued-bd-ref {
    cursor: help;
    border-bottom: 1px dashed #dcdfe6;
    transition: border-color 0.15s ease, color 0.15s ease;
}

.issued-bd-ref--click {
    cursor: pointer;
}

.issued-bd-ref--click:focus,
.issued-bd-ref--click:focus-visible,
.issued-bd-ref--click:active {
    outline: none !important;
    box-shadow: none !important;
}

.issued-bd-ref:hover {
    border-bottom-color: #e6a23c;
    color: #cf9236;
}

/* ── 发分来源类型管理弹窗 ── */
.grant-source-type-panel {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.grant-source-type-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
    border-radius: 8px;
}

.grant-source-type-toolbar__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.grant-source-type-toolbar__hint {
    flex: 1;
    min-width: 180px;
    font-size: 12px;
    color: #94a3b8;
    text-align: right;
    line-height: 1.5;
}

.grant-source-type-table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.grant-source-type-table-wrap ::v-deep .el-table {
    border-radius: 8px;
}

.grant-source-type-table-wrap ::v-deep .el-table::before {
    display: none;
}

.grant-source-type-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 280px;
    padding: 24px 16px;
    color: #909399;
}

.grant-source-type-empty__icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 12px;
}

.grant-source-type-empty__title {
    margin: 0 0 6px;
    font-size: 15px;
    font-weight: 600;
    color: #606266;
}

.grant-source-type-empty__desc {
    margin: 0;
    font-size: 13px;
    color: #909399;
    text-align: center;
    max-width: 320px;
    line-height: 1.6;
}

.grant-source-type-color-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 8px 2px 4px;
    border-radius: 999px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
}

.grant-source-type-color-dot {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
    flex-shrink: 0;
}

.grant-source-type-color-hex {
    font-family: Consolas, Monaco, monospace;
    font-size: 11px;
    color: #64748b;
    text-transform: lowercase;
}

.grant-source-type-color-empty {
    font-size: 12px;
    color: #c0c4cc;
}

.grant-source-type-op-btn.is-danger {
    color: #f56c6c;
}

.grant-source-type-footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 4px;
}

.grant-source-type-init-desc {
    margin: 0 0 12px;
    font-size: 13px;
    color: #606266;
    line-height: 1.6;
}

.grant-source-type-init-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.grant-source-type-init-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
}

.grant-source-type-init-swatch {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    flex-shrink: 0;
}

.grant-source-type-init-name {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.grant-source-type-init-hex {
    font-family: Consolas, Monaco, monospace;
    font-size: 12px;
    color: #94a3b8;
}

.grant-source-type-init-footer {
    text-align: right;
}

::v-deep .grant-source-type-dialog .el-dialog__body {
    padding-top: 8px;
    padding-bottom: 16px;
}

::v-deep .grant-source-type-init-dialog .el-dialog__body {
    padding-top: 4px;
    padding-bottom: 8px;
}

/* 分页固定在区块右下角（flex 比 text-align 对 el-pagination 更可靠） */
.pagination-bar {
    flex: 0 0 auto;
    margin-top: 12px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.writeoff-revoked-hint {
    font-size: 12px;
    color: #c0c4cc;
    user-select: none;
}

.score-value {
    color: var(--btn-primary, #2563eb);
    font-weight: 600;
}

.score-issued {
    color: #E6A23C;
    font-weight: 600;
}

.score-remain {
    color: #67C23A;
    font-weight: 600;
}

.score-zero {
    color: #909399;
}

/* 流动红旗查询 */
.query-bar {
    flex: 0 0 auto;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 0;
}

.query-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.flag-count {
    color: #e6a23c;
    font-weight: bold;
    font-size: 15px;
}

.flag-zero {
    color: #c0c4cc;
}

/* 流动红旗明细 — 表内摘要卡片（点击打开弹窗） */
.flag-summary-card {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 8px;
    cursor: pointer;
    text-align: left;
    transition: border-color .2s, box-shadow .2s, background .2s;
    outline: none;
}

.flag-summary-card:last-child {
    margin-bottom: 0;
}

.flag-summary-card:hover,
.flag-summary-card:focus {
    border-color: #b3d8ff;
    background: #f5fafe;
    box-shadow: 0 1px 4px rgba(64, 158, 255, .12);
}

.flag-summary-card.is-normal {
    border-left: 3px solid #67c23a;
}

.flag-summary-card.is-manual {
    border-left: 3px solid #e6a23c;
}

.flag-summary-card.is-canceled {
    border-left: 3px solid #909399;
    opacity: .92;
}

.flag-summary-card-top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
}

.flag-summary-period {
    font-weight: 600;
    color: #303133;
    font-size: 13px;
    line-height: 1.4;
}

.flag-summary-score {
    flex-shrink: 0;
    font-weight: 700;
    font-size: 14px;
    color: #e6a23c;
    padding: 2px 8px;
    border-radius: 4px;
    background: rgba(230, 162, 60, .1);
}

.flag-summary-card-mid {
    margin-top: 6px;
    font-size: 12px;
    color: #606266;
    line-height: 1.45;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 12px;
}

.flag-summary-flagname {
    color: var(--btn-primary, #2563eb);
}

.flag-summary-card-foot {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    font-size: 12px;
    color: #909399;
}

.flag-summary-tip {
    letter-spacing: .02em;
}

.flag-summary-card-foot .el-icon-arrow-right {
    font-size: 12px;
}

.writeoff-pool-form-item>>>.el-form-item__content {
    line-height: 1.45;
}

.writeoff-pool-hint-wrap {
    min-height: 52px;
    width: 100%;
}

.writeoff-pool-card {
    width: 100%;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #fafbfc;
    overflow: hidden;
}

.writeoff-pool-hero {
    padding: 12px 14px 10px;
    background: linear-gradient(135deg, #fff8ee 0%, #fff 100%);
    border-bottom: 1px solid #f0f2f5;
}

.writeoff-pool-hero-label {
    font-size: 12px;
    color: #909399;
    line-height: 1.2;
}

.writeoff-pool-hero-value {
    margin-top: 4px;
    font-size: 28px;
    font-weight: 700;
    color: #e6a23c;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
}

.writeoff-pool-hero-tip {
    margin-top: 4px;
    font-size: 12px;
    color: #b88230;
}

.writeoff-pool-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
}

/* 新模式仅两项：左右各一，去掉底边空洞感 */
.writeoff-pool-stats--pair .writeoff-pool-stat {
    border-bottom: none;
}

.writeoff-pool-stat {
    padding: 10px 14px;
    border-right: 1px solid #f0f2f5;
    border-bottom: 1px solid #f0f2f5;
}

.writeoff-pool-stat:nth-child(2n) {
    border-right: none;
}

.writeoff-pool-stat:nth-last-child(-n+2) {
    border-bottom: none;
}

.writeoff-pool-stat-label {
    font-size: 12px;
    color: #909399;
    line-height: 1.2;
}

.writeoff-pool-stat-value {
    margin-top: 4px;
    font-size: 16px;
    font-weight: 700;
    color: #606266;
    font-variant-numeric: tabular-nums;
}

.writeoff-pool-stat-value--avail {
    color: #67c23a;
}

.writeoff-pool-stat-value--gross {
    color: var(--btn-primary, #2563eb);
}

.writeoff-pool-deduct-note {
    font-size: 12px;
    color: #909399;
    line-height: 1.45;
    padding: 8px 14px 10px;
    border-top: 1px solid #f0f2f5;
    background: #fff;
}

.writeoff-deduct-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 6px;
}

.writeoff-deduct-tip strong {
    color: #e6a23c;
}

.writeoff-pool-miss {
    font-size: 12px;
    color: #e6a23c;
    line-height: 1.5;
}

/* 流动红旗详情弹窗内容 */
.flag-detail-sheet {
    text-align: left;
}

.flag-detail-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #ebeef5;
}

.flag-detail-hero-label {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.45;
}

.flag-detail-hero-score {
    font-size: 20px;
    font-weight: 700;
    color: #e6a23c;
    line-height: 1.2;
}

.flag-detail-rows {
    font-size: 13px;
    color: #606266;
    line-height: 1.55;
}

.flag-detail-row {
    display: flex;
    margin-bottom: 8px;
    align-items: flex-start;
}

.flag-detail-row:last-child {
    margin-bottom: 0;
}

.flag-detail-k {
    flex: 0 0 56px;
    color: #909399;
}

.flag-detail-v {
    flex: 1;
    word-break: break-word;
}

.flag-detail-sub {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: #909399;
}

.flag-detail-block {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px dashed #ebeef5;
}

.flag-detail-block-body {
    margin-top: 4px;
    color: #303133;
}

.flag-detail-block--manual .flag-detail-k {
    color: #e6a23c;
}

.flag-detail-block--cancel .flag-detail-k {
    color: #f56c6c;
}

/* 汇总排行 */
.rank-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    padding: 0 4px 12px;
    border-left: 3px solid var(--btn-primary, #2563eb);
    padding-left: 10px;
    margin-bottom: 8px;
}

.medal {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
}

.medal-gold {
    background: #f5a623;
}

.medal-silver {
    background: #9b9b9b;
}

.medal-bronze {
    background: #c67b3a;
}

.rank-num {
    color: #606266;
    font-size: 13px;
}
</style>

<style>
/* 已发/可兑构成弹窗（append-to-body，需非 scoped） */
.issued-bd-dialog-shell.el-dialog {
    border-radius: 12px;
    overflow: hidden;
}

.issued-bd-dialog-shell .el-dialog__header {
    padding: 18px 22px 10px;
}

.issued-bd-dialog-shell .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #171717;
    letter-spacing: 0.01em;
}

.issued-bd-dialog-shell .el-dialog__body {
    padding: 4px 22px 8px;
}

.issued-bd-dialog-shell .el-dialog__footer {
    padding: 8px 22px 18px;
}

.issued-bd-dialog-shell .issued-bd-pop {
    min-width: 280px;
    box-sizing: border-box;
    text-align: left;
}

/* 新模式：极简账本式说明 */
.issued-bd-dialog-shell .pool-explain {
    --pe-ink: #171717;
    --pe-muted: #737373;
    --pe-line: #e5e5e5;
    --pe-soft: #fafafa;
    --pe-accent: #b45309;
}

.issued-bd-dialog-shell .pool-explain-answer {
    padding: 8px 0 18px;
}

.issued-bd-dialog-shell .pool-explain-eyebrow {
    font-size: 12px;
    font-weight: 500;
    color: var(--pe-muted);
    letter-spacing: 0.04em;
    margin-bottom: 8px;
}

.issued-bd-dialog-shell .pool-explain-num {
    font-size: 44px;
    line-height: 1;
    font-weight: 700;
    color: var(--pe-ink);
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.03em;
}

.issued-bd-dialog-shell .pool-explain-meta {
    margin-top: 8px;
    font-size: 12px;
    color: var(--pe-muted);
}

.issued-bd-dialog-shell .pool-explain-ledger {
    border: 1px solid var(--pe-line);
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
}

.issued-bd-dialog-shell .pool-explain-ledger-cap {
    padding: 12px 16px 8px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: none;
    color: var(--pe-muted);
    background: var(--pe-soft);
    border-bottom: 1px solid var(--pe-line);
}

.issued-bd-dialog-shell .pool-explain-ledger-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.issued-bd-dialog-shell .pool-explain-ledger-grid .pool-explain-row {
    border-bottom: 1px solid #f0f0f0;
}

.issued-bd-dialog-shell .pool-explain-ledger-grid .pool-explain-row:nth-child(odd) {
    border-right: 1px solid #f0f0f0;
}

@media (max-width: 440px) {
    .issued-bd-dialog-shell .pool-explain-ledger-grid {
        grid-template-columns: 1fr;
    }

    .issued-bd-dialog-shell .pool-explain-ledger-grid .pool-explain-row:nth-child(odd) {
        border-right: none;
    }
}

.issued-bd-dialog-shell .pool-explain-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    font-variant-numeric: tabular-nums;
    transition: background-color 0.15s ease;
    min-width: 0;
}

.issued-bd-dialog-shell .pool-explain-row.is-total {
    background: var(--pe-soft);
    border-top: 1px solid var(--pe-line);
}

.issued-bd-dialog-shell .pool-explain-row-k {
    font-size: 13px;
    color: #404040;
}

.issued-bd-dialog-shell .pool-explain-row.is-total .pool-explain-row-k {
    color: var(--pe-ink);
    font-weight: 600;
}

.issued-bd-dialog-shell .pool-explain-row-v {
    font-size: 15px;
    font-weight: 600;
    color: var(--pe-ink);
    min-width: 64px;
    text-align: right;
}

.issued-bd-dialog-shell .pool-explain-row-v.is-total-v {
    color: var(--pe-accent);
    font-size: 18px;
    font-weight: 700;
}

.issued-bd-dialog-shell .pool-explain-note {
    margin: 12px 0 0;
    font-size: 12px;
    line-height: 1.6;
    color: var(--pe-muted);
}

.issued-bd-dialog-shell .pool-explain-more {
    margin-top: 14px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #2563eb;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: color 0.15s ease;
}

.issued-bd-dialog-shell .pool-explain-more:hover {
    color: #1d4ed8;
}

.issued-bd-dialog-shell .pool-explain-history {
    margin-top: 12px;
    padding-top: 4px;
}

.issued-bd-dialog-shell .pool-explain-history-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.issued-bd-dialog-shell .pool-explain-history-item {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid var(--pe-line);
    border-radius: 8px;
    background: #fff;
    font-variant-numeric: tabular-nums;
}

.issued-bd-dialog-shell .pool-explain-history-k {
    font-size: 12px;
    color: var(--pe-muted);
}

.issued-bd-dialog-shell .pool-explain-history-v {
    font-size: 13px;
    font-weight: 600;
    color: var(--pe-ink);
}

.issued-bd-dialog-shell .issued-bd-hero {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 4px;
}

.issued-bd-dialog-shell .issued-bd-stat-pair {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.issued-bd-dialog-shell .issued-bd-stat-card {
    background: linear-gradient(165deg, #fafbfd 0%, #f0f2f5 100%);
    border: 1px solid #e4e7ed;
    border-radius: 10px;
    padding: 12px 14px 14px;
    text-align: center;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.issued-bd-dialog-shell .issued-bd-stat-card--wide {
    text-align: left;
}

.issued-bd-dialog-shell .issued-bd-stat-caption {
    font-size: 12px;
    color: #909399;
    font-weight: 600;
    letter-spacing: 0.02em;
    margin-bottom: 6px;
}

.issued-bd-dialog-shell .issued-bd-stat-value {
    font-size: 24px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    line-height: 1.15;
    letter-spacing: -0.02em;
}

.issued-bd-dialog-shell .issued-bd-stat-hint {
    margin: 10px 0 0;
    font-size: 11px;
    color: #a8abb2;
    line-height: 1.5;
}

.issued-bd-dialog-shell .issued-bd-mode-note {
    margin: 0 0 10px;
    padding: 0;
    font-size: 12px;
    line-height: 1.6;
    color: #737373;
    background: transparent;
}

.teacher-quota-dialog-shell .teacher-quota-simple-tip {
    margin: 0 0 12px;
    font-size: 13px;
    line-height: 1.55;
    color: #404040;
}

.teacher-quota-dialog-shell .teacher-quota-simple-tip--muted {
    margin-top: 10px;
    color: #737373;
    font-size: 12px;
}

.teacher-quota-dialog-shell .teacher-quota-dialog-summary {
    background: #fafafa;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
}

.issued-bd-dialog-shell .issued-bd-collapse {
    border: none;
}

.issued-bd-dialog-shell .issued-bd-collapse >>> .el-collapse-item__header {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    height: 42px;
    line-height: 42px;
    border-bottom-color: #ebeef5;
}

.issued-bd-dialog-shell .issued-bd-collapse >>> .el-collapse-item__wrap {
    border-bottom: none;
}

.issued-bd-dialog-shell .issued-bd-collapse >>> .el-collapse-item__content {
    padding-bottom: 8px;
}

.issued-bd-dialog-shell .issued-bd-section-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 16px 0 12px;
}

.issued-bd-dialog-shell .issued-bd-section-title {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    flex-shrink: 0;
}

.issued-bd-dialog-shell .issued-bd-section-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, #dcdfe6 0%, rgba(220, 223, 230, 0.2) 100%);
}

@media (max-width: 440px) {
    .issued-bd-dialog-shell .issued-bd-stat-pair {
        grid-template-columns: 1fr;
    }
}

.issued-bd-dialog-shell .issued-bd-dialog-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    padding: 10px 12px;
    background: #f5f7fa;
    border-radius: 6px;
    border: 1px solid #ebeef5;
}

.issued-bd-dialog-shell .issued-bd-dialog-summary--stack {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
}

.issued-bd-dialog-shell .issued-bd-summary-block {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 10px;
}

.issued-bd-dialog-shell .issued-bd-dialog-summary-label {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    flex: 1;
    min-width: 0;
}

.issued-bd-dialog-shell .issued-bd-dialog-summary-nums {
    display: flex;
    align-items: baseline;
    flex-shrink: 0;
    font-variant-numeric: tabular-nums;
}

.issued-bd-dialog-shell .issued-bd-dialog-summary-sep {
    color: #c0c4cc;
    font-size: 16px;
    font-weight: 500;
    margin: 0 6px;
    line-height: 1;
}

.issued-bd-dialog-shell .issued-bd-dialog-summary-num {
    font-size: 18px;
    font-weight: 700;
}

.issued-bd-dialog-shell .issued-bd-num-avail {
    color: #67c23a;
}

.issued-bd-dialog-shell .issued-bd-num-gross {
    color: var(--btn-primary, #2563eb);
}

.issued-bd-dialog-shell .issued-bd-num-redeem {
    color: #e6a23c;
}

/* 构成分项：桌面两列，小屏单列 */
.issued-bd-dialog-shell .issued-bd-lines {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.issued-bd-dialog-shell .issued-bd-line {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #fff;
    min-width: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.035);
}

.issued-bd-dialog-shell .issued-bd-label {
    font-size: 12px;
    color: #909399;
    line-height: 1.35;
    flex: 1;
    min-width: 0;
}

.issued-bd-dialog-shell .issued-bd-val {
    font-size: 13px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
    min-width: 2.2em;
    text-align: right;
}

.issued-bd-dialog-shell .issued-val-pos {
    color: #67c23a;
}

.issued-bd-dialog-shell .issued-val-neg {
    color: #f56c6c;
}

.issued-bd-dialog-shell .issued-val-zero {
    color: #c0c4cc;
}

.issued-bd-dialog-shell .issued-val-warn {
    color: #e6a23c;
}

.issued-bd-dialog-shell .issued-bd-diff {
    margin-top: 12px;
    padding: 10px 12px;
    border-radius: 6px;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
}

.issued-bd-dialog-shell .issued-bd-diff-label {
    font-size: 12px;
    color: #e6a23c;
    font-weight: 500;
}

/* 仅极窄屏单列；普通手机横屏 / 小窗仍保持「两项并排」 */
@media (max-width: 400px) {
    .issued-bd-dialog-shell .issued-bd-lines {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 520px) {
    .issued-bd-dialog-shell.el-dialog {
        width: 92% !important;
        margin-top: 8vh !important;
    }
}

/* 任课额度明细弹窗（append-to-body） */
.teacher-quota-dialog-shell .el-dialog__body {
    padding: 8px 20px 12px;
}

.teacher-quota-dialog-shell .teacher-quota-dialog-summary {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-bottom: 12px;
    padding: 12px 14px;
    background: #f5f7fa;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    text-align: center;
}

.teacher-quota-dialog-shell .teacher-quota-dialog-summary--sub {
    background: #fff;
    border-style: dashed;
}

.teacher-quota-dialog-shell .teacher-quota-dialog-summary-label {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
}

.teacher-quota-dialog-shell .teacher-quota-dialog-summary-nums {
    font-size: 15px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.teacher-quota-dialog-shell .teacher-quota-dialog-footer {
    text-align: center;
}

.teacher-quota-dialog-shell .teacher-quota-stale-alert {
    margin-bottom: 12px;
}

/* 仅作边框容器；纵向滚动交给 dialog-theme 的表体 max-height，避免双滚动条。最后修改：2026-09-20 */
.teacher-quota-dialog-shell .teacher-quota-table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
}

/* ElementUI bordered 表：最后一列右边框与表体右侧 ::after 叠层，易显「多一列 + 线更粗」——只去掉右侧伪线 */
.teacher-quota-dialog-shell .teacher-quota-detail-table--lite.el-table--border::after {
    display: none !important;
}

.teacher-quota-dialog-shell .teacher-quota-detail-table--lite.el-table--border {
    border-right: none;
    border-radius: 0;
}

.teacher-quota-dialog-shell .teacher-quota-detail-table--lite.el-table--border th,
.teacher-quota-dialog-shell .teacher-quota-detail-table--lite.el-table--border td {
    border-right-color: #ebeef5;
    border-bottom-color: #ebeef5;
}

.teacher-quota-dialog-shell .teacher-quota-detail-table {
    width: 100%;
}

.teacher-quota-dialog-shell .teacher-quota-detail-table .cell {
    text-align: center;
}

.teacher-quota-dialog-shell .teacher-quota-empty {
    padding: 24px 12px;
    text-align: center;
    font-size: 13px;
    color: #909399;
    line-height: 1.5;
}

@media (max-width: 600px) {
    .teacher-quota-dialog-shell.el-dialog {
        width: 92% !important;
    }
}

/* 流动红旗详情对话框（append-to-body 时保证内边距与窄屏宽度） */
.flag-detail-dialog-shell .el-dialog__body {
    padding: 8px 20px 4px;
}

@media (max-width: 520px) {
    .flag-detail-dialog-shell.el-dialog {
        width: 92% !important;
        margin-top: 8vh !important;
    }
}
</style>
